import { useState, useCallback, useEffect, useRef } from 'react';
import Frame1 from "./Frame1.jsx";
import PortalPopup from "./PortalPopup.jsx";
import atlas from 'azure-maps-control';
import Frame from "./Frame.jsx";
import axios from 'axios';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Scheduler from '../calendar/Scheduler.jsx';
import BankDetailsMain from '../bankDetails/bankDetailsMain.jsx';
import ReviewAndConfirm from '../reviewConfirm/reviewandConfirm.jsx';
import { GrFormSearch } from "react-icons/gr";
import MarkingAlert from '../NavBar/MarkingAlert.jsx';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';
import FadeLoader from "react-spinners/FadeLoader";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { useNavigate } from "react-router-dom";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RoboTaxiPopup from './RoboTaxiPopup.jsx';
import { fetchParkinglotDetailsbyentityid } from '../../Services/parkinglotService'
import InfoIcon from "@mui/icons-material/Info";
import { FiTrash2 } from "react-icons/fi";
import { area } from '@turf/turf';



const MapDashboard = (props) => {
	const { overrides, mapVisibleChangesAlert = () => { }, defaultaddress, userData, employeeData, ...rest } = props;

	const markerMap = useRef({});
	const mapRef = useRef(null);
	const markerEnabled = useRef(false);
	let map = useRef(null);
	const [UpdatepslNames, setUpdatepslNames] = useState(false);
	const [expanded, setExpanded] = useState(false);
	const hostPath = process.env.REACT_APP_API_BASE_URL;
	const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
	const [isFrameOpen, setFrameOpen] = useState(true);
	const [isFrame1Open, setFrame1Open] = useState(false);
	const [isAddressSelected, setConfirmAddress] = useState(false)
	const [isScheduleAvailabilityPopupConfirm, setConfirmforScheduleAvailability] = useState(true)
	const [searchValue, setSearchValue] = useState('');
	const [suggestions, setSuggestions] = useState([]);
	const [selecetedAddress, setSelecetedAddress] = useState([]);
	const [selectedAddLanLot, setSelectedAddLanLot] = useState([]);
	const [searchError, setSearchError] = useState(false);
	const [issearchdisabled, setSearchdisabled] = useState(false);
	const [addressvalue, setAddressvalue] = useState('');
	const [selectedOption, setSelectedOption] = useState([]);
	const [currentPropertyaddress, setCurrentpropertyaddress] = useState();
	const [areasMarked, setareasmarked] = useState(props.areasMarked || []);
	const originalareasMarked = props.areasMarked || [];
	const [areaMarkedStatus, setAreaMarkedStatus] = useState('false');
	const [roboTaxiPopup, setRoboTaxiPopup] = useState(false);
	const [roboTaxiAlert, setRoboTaxiAlert] = useState(false);
	const [roboTaxiLimit, setRoboTaxiLimit] = useState(Number(props?.parkinglotObj?.maxRoboTaxiSpots) || 0);
	const [pslCount, setPslCount] = useState(0);
	const [roboTaxiCountError, setRoboTaxiCountError] = useState('');
	const [isLimitButton, setIsLimitButton] = useState(false);
	const [pslPage, setPslPage] = useState(false)
	const htmlMarkers = useRef([]);
	const [showSpotSizePopup, setShowSpotSizePopup] = useState(false);
	const [, setSpotPopupPosition] = useState(null);
	const [pendingMarkerData, setPendingMarkerData] = useState(null);
	const isPopupLockedRef = useRef(false);
	const [isPopupLocked, setIsPopupLocked] = useState(false);
	const [duplicateAddressError, setDuplicateAddressError] = useState(false);
	const [parkingLotBookingDetails, setParkingLotBookingDetails] = useState([]);
	const [selectedCountry, setSelectedCountry] = useState('' || props?.parkinglotObj?.region || props?.defaultRegion || props?.userData?.country || props?.employeeData?.country);
	const [autoApplySize, setAutoApplySize] = useState(null);
	const [toastMessage, setToastMessage] = useState(null);
	const [toastId, setToastId] = useState(null);
	const [, setRoboTaxiSpotsName] = useState([]);
	const [groupSchedule, setGroupSchedules] = useState([]);
	const entity = props.entityId || props.parkinglotObj?.entityRegistrationID
	const [currentStep, setCurrentStep] = useState(1);


	const [savedRoboTaxiPSLs, setSavedRoboTaxiPSLs] = useState([]);

	const [draftRoboTaxiPSLs, setDraftRoboTaxiPSLs] = useState([]);




	useEffect(() => {
		if (roboTaxiPopup) {
			setDraftRoboTaxiPSLs([...savedRoboTaxiPSLs]);
			setRoboTaxiCountError("");
		}
	}, [roboTaxiPopup]);


	useEffect(() => {
		const apiPSLs = props.parkinglotObj?.roboTaxiSpotsName;



		if (
			props.parkinglotObj?.isRoboTaxiSelected &&
			Array.isArray(apiPSLs) &&
			apiPSLs.length > 0
		) {
			setSavedRoboTaxiPSLs(apiPSLs);          // 🔴 THIS WAS MISSING
			setDraftRoboTaxiPSLs(apiPSLs);
			setSelectedPSLCheckboxes(apiPSLs);
			setRoboTaxiLimit(apiPSLs.length);
			setRoboTaxis(true);
		} else {
			setSavedRoboTaxiPSLs([]);
			setDraftRoboTaxiPSLs([]);
			setSelectedPSLCheckboxes([]);
			setRoboTaxiLimit(0);
			setRoboTaxis(false);
		}
	}, [props.parkinglotObj]);


	useEffect(() => {
		if (pendingMarkerData && autoApplySize) {
			handleSpotSizeApply(autoApplySize);
			setAutoApplySize(null);
		}
	}, [pendingMarkerData, autoApplySize]);

	useEffect(() => {
		if (!toastMessage) return;
		toast.dismiss(); // Clear previous toasts
		toast.success(toastMessage, {
			toastId,
			position: "top-right",
			autoClose: 1000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: false,
			draggable: false,
		});
		setToastMessage(null); // Prevent duplicate display
	}, [toastMessage, toastId]);

	const assignRoboTaxiSpots = (pslList, limit) => {
		const selected = pslList
			.filter(p => p.pslName)
			.slice(0, limit)
			.map(p => p.pslName);

		setRoboTaxiSpotsName(selected);
	};
	useEffect(() => {
		if (roboTaxiLimit > 0 && areasMarked?.length) {
			assignRoboTaxiSpots(areasMarked, roboTaxiLimit);
		}
	}, [roboTaxiLimit, areasMarked]);


	// NEW: Separate state for blue pin to isolate it from business logic
	const [, setBluePinMarker] = useState(null);
	const bluePinRef = useRef(null);
	const pslCounterRef = useRef(0);

	const [selectedGroupFilter, setSelectedGroupFilter] = useState('Default');
	const [selectedPSLCheckboxes, setSelectedPSLCheckboxes] = useState([]);

	useEffect(() => {

		if (props?.parkinglotObj?.groupSchedules) {
			setGroupSchedules(props.parkinglotObj.groupSchedules);
		}
	}, [props?.parkinglotObj]);

	// Groups state
	const groupColors = ["rgb(6, 246, 234)", "#ea0bdbff", "rgb(252, 104, 5)", "#0c25e0ff"];

	const [groups, setGroups] = useState([
		{ id: 1, name: "Default", color: "green", editing: false },
	]);
	const [selectedGroup, setSelectedGroup] = useState("Default");

	// Accordion expand/collapse
	const [expandedGroups, setExpandedGroups] = useState(true);
	const handleGroupsAccord = (event, isExpanded) => {
		setExpandedGroups(isExpanded);
	};
	const getNextAvailableColor = (groups, palette) => {
		const usedColors = groups.map(g => g.color);
		return palette.find(c => !usedColors.includes(c)) || palette[0];
	};
	const MAX_GROUP_NAME_LENGTH = 15;
	// Add group (inline edit enabled by default)
	const handleAddGroup = () => {
		if (groups.length >= 5) {
			toast.warn("You can only create up to 5 groups.");
			return;
		}
		const nextColor = getNextAvailableColor(groups, groupColors);
		const newGroup = {
			id: Date.now(),
			name: "",
			color: nextColor,
			editing: true,
			toggle: false,
		};

		setGroups((prev) => [...prev, newGroup]);
		setSelectedGroup("");
	};

	// ✅ Save (Rename) group name while keeping PSLs linked
	const handleSaveGroupName = (id, newName) => {
		const trimmed = newName.trim();
		if (!trimmed) {
			toast.error("Group name cannot be empty.");
			return;
		}
		if (trimmed.length > MAX_GROUP_NAME_LENGTH) {
			toast.error(`Group name cannot be more than ${MAX_GROUP_NAME_LENGTH} characters.`);
			return;
		}
		const exists = groups.some(
			(g) =>
				g.name.toLowerCase() === trimmed.toLowerCase() &&
				g.id !== id
		);
		if (exists) {
			toast.error("Group name already exists. Please choose another name.");
			return;
		}
		// Get old name before updating
		const oldGroup = groups.find((g) => g.id === id);
		const oldName = oldGroup?.name;
		// ✅ Update group name (color & id stay same)
		setGroups((prev) =>
			prev.map((g) => (g.id === id ? { ...g, name: trimmed, editing: false } : g))
		);
		// ✅ Update all PSL markers belonging to this group
		setareasmarked((prev) =>
			prev.map((marker) =>
				marker.Name === "PSL - Parking Space Location" &&
					marker.groupName === oldName
					? { ...marker, groupName: trimmed }
					: marker
			)
		);
		// ✅ Update selected group if it's the same
		if (selectedGroup === oldName) {
			setSelectedGroup(trimmed);
		}

		// toast.success("Group Created successfully.");
		setToastMessage("Group Created successfully.");
		setToastId("createGroup");
		toast.dismiss();
		return;
	};


	// Edit existing group name
	const handleEditGroup = (id) => {
		setGroups((prev) =>
			prev.map((g) => (g.id === id ? { ...g, editing: true } : g))
		);
	};
	// Delete group
	const handleDeleteGroup = (id) => {
		const groupToDelete = groups.find(g => g.id === id);
		if (!groupToDelete) return;
		// Reassign all PSL markers from deleted group to "Default"
		setareasmarked((prev) =>
			prev.map((marker) => {
				if (marker.Name === "PSL - Parking Space Location" && marker.groupName === groupToDelete.name) {
					return {
						...marker,
						groupName: "Default"
					};
				}
				return marker;
			})
		);
		// Remove the group
		setGroups((prev) => prev.filter((g) => g.id !== id));

		// Update selected group if needed
		if (selectedGroup === groupToDelete.name) {
			setSelectedGroup("Default");
		}
		toast.info(`Group Name "${groupToDelete.name}" deleted.`);
	};

	useEffect(() => {
		const fetchParkinglotdetails = async () => {
			try {
				const parkingDetails = await fetchParkinglotDetailsbyentityid(entity);

				setParkingLotBookingDetails(parkingDetails);
			} catch (error) {
				console.error("Error fetching parking lot details:", error);
			} finally {
				setLoader(false);
			}
		};
		fetchParkinglotdetails();
	}, [entity]);

	function hasAreaChanged(originalMarkers, newMarkers) {
		if (originalMarkers.length !== newMarkers.length) {
			return true;
		}

		for (let i = 0; i < originalMarkers.length; i++) {
			const original = originalMarkers[i];
			const updated = newMarkers[i];

			const sameCoords =
				String(original.Coordinates?.Latitude) === String(updated.Coordinates?.Latitude) &&
				String(original.Coordinates?.Longitude) === String(updated.Coordinates?.Longitude);

			const originalName = original.Name || original.title;
			const updatedName = updated.Name || updated.title;
			const sameTitle = originalName === updatedName;

			if (!sameTitle || !sameCoords) {
				return true;
			}
		}

		return false;
	}

	useEffect(() => {
		const changed = hasAreaChanged(originalareasMarked, areasMarked);
		mapVisibleChangesAlert(changed);
		setAreaMarkedStatus(changed)

	}, [areasMarked, selectedGroup, groups])

	const [scheduleavailability, setscheduleavailability] = useState(false);
	const [selectedValue, setSelectedValue] = useState('');
	const [bankaccountdetails, setbankaccountdetails] = useState({});
	const [alertpopup, setAlertpopup] = useState(false);
	const [optionerror, setOptionerror] = useState(false);
	const [expandedMark, setExpandedMark] = useState(true)
	const [expandedMarkSpace, setExpandedMarkSpace] = useState(true)
	const [weekoption, setWeekoption] = useState();
	const [streetname, setStreetname] = useState();
	const [currentProperty, setCurrentproperty] = useState();
	const [isDashboard, setDashboard] = useState(false)
	const [parkinglotId, setParkinglotId] = useState();
	const [loader, setLoader] = useState(false);
	const empentity = props?.empRegistrationId || props?.parkinglotObj?.empRegistrationId
	const [selectedDate, setSelectedDate] = useState(new Date());
	const [selectedMarkOption, setMarkOption] = useState(false)
	const [onlyPark, setOnlyPark] = useState(false);
	const [RoboTaxis, setRoboTaxis] = useState(false);
	const [selectedRoboTaxiOption, setSelectedRoboTaxiOption] = useState(false);
	const [showPickUPSDropoffs, setShowPickUPSDropoffs] = useState(false);
	const [showParkOnly, setshowParkOnly] = useState(true)
	const [, SetEventTriggered] = useState(false)
	const [SelectedBankDetailID, setSelectedBankDetailID] = useState(0)

	const [PropertyNickName, setPropertyNickName] = useState(
		String(props.parkinglotObj?.nickName ?? "")
	);
	const oldNickName = String(props.parkinglotObj?.nickName ?? "");
	const [nickNameStatus, setNickNameStatus] = useState(false);
	const [isScheduleDeleted, setIsScheduleDeleted] = useState(false);




	const steps = [
		"1 of 6 - Locate your Property",
		"2 of 6 - Mark Parking Spaces",
		"3 of 6 - Pick ups and  Drop offs",
		"4 of 6 - Schedule Availability",
		"5 of 6 - Enter Bank Details",
		"6 of 6 - Review and Confirm"
	];
	const stepParkOnly = [
		"1 of 5 - Locate your Property",
		"2 of 5 - Mark Parking Spaces",
		"3 of 5 - Schedule Availability",
		"4 of 5 - Enter Bank Details",
		"5 of 5 - Review and Confirm"
	];

	const [areas, setAreas] = useState({
		"PSL - Parking Space Location": 0,
		"PKE - Parking Entrance": 0,
		"PKX - Parking Exit": 0,
	});

	const [PickUPSDropoffs, setPickUPSDropoffs] = useState({
		"PUE - Pick Up Entrance": 0,
		"DOE - Drop Off Entrance": 0,
		"PUL - Pick Up Location": 0,
		"DOL - Drop Off Location": 0,
		"PUX - Pick Up Exit": 0,
		"DOX - Drop Off Exit": 0
	});

	// NEW: Function to get filtered areasMarked without blue pin
	const getBusinessAreasMarked = () => {
		return areasMarked.filter(area => area.Name !== "Searched Location");
	};

	const PICK_DROP_TYPES = [
  "PUE - Pick Up Entrance",
  "DOE - Drop Off Entrance",
  "PUL - Pick Up Location",
  "DOL - Drop Off Location",
  "PUX - Pick Up Exit",
  "DOX - Drop Off Exit"
];

	const selectOption = (event) => {
		const { name, checked } = event.target;

		if (checked) {
			setMarkOption(name);
			setOnlyPark(true);
			setSelectedGroup("Default");
			setShowPickUPSDropoffs(false);   // 🔴 hide pickup flow
			// 🔥 REMOVE all PickUp / DropOff markers
			setareasmarked(prev =>
				prev.filter(m => !PICK_DROP_TYPES.includes(m.Name))
			);
			setPickUPSDropoffs({
				"PUE - Pick Up Entrance": 0,
				"DOE - Drop Off Entrance": 0,
				"PUL - Pick Up Location": 0,
				"DOL - Drop Off Location": 0,
				"PUX - Pick Up Exit": 0,
				"DOX - Drop Off Exit": 0
			});
			//const updateAreas = getBusinessAreasMarked()?.filter((name) => (name.Name === "PSL - Parking Space Location") || (name.Name === "PKE - Parking Entrance") || (name.Name === "PKX - Parking Exit"))
			//setareasmarked(updateAreas)
			setShowSpotSizePopup(false);
			setSpotPopupPosition(false);
		} else {
			setPickUPSDropoffs({
				"PUE - Pick Up Entrance": 0,
				"DOE - Drop Off Entrance": 0,
				"PUL - Pick Up Location": 0,
				"DOL - Drop Off Location": 0,
				"PUX - Pick Up Exit": 0,
				"DOX - Drop Off Exit": 0
			});
			setMarkOption('');
			setOnlyPark(false);
			setSelectedGroup("Default");
			setShowSpotSizePopup(false);
			setSpotPopupPosition(false);
		}
	};

	const AssignRoboTaxiSpaces = (event) => {
		const { name, checked } = event.target;

		if (checked) {
			setRoboTaxis(true);
			//setSelectedRoboTaxiOption(name);
			setRoboTaxiPopup(true);
			setDraftRoboTaxiPSLs([...savedRoboTaxiPSLs]);
			setSelectedPSLCheckboxes([...savedRoboTaxiPSLs]);
			setRoboTaxiAlert(true);
		}
		else {
			setSavedRoboTaxiPSLs([]);
			setDraftRoboTaxiPSLs([]);
			setSelectedPSLCheckboxes([]);
			setSelectedRoboTaxiOption('');
			setRoboTaxiLimit(0);
			setRoboTaxis(false);
			setRoboTaxiPopup(false);
			setRoboTaxiAlert(false);
		}
	}

	const [events, setEvents] = useState([]);

	// useEffect(() => {
	// 	console.log("events", events);

	// }, [events])

	useEffect(() => {
		if (!props?.parkinglotObj?.groupSchedules) return;

		const masters = props.parkinglotObj.groupSchedules.flatMap(group =>
			(group.schedules || []).map(s => ({
				...s,
				groupName: group.groupName || "Default",
				isMaster: true
			}))
		);

		const expanded = expandGroupSchedules(
			props.parkinglotObj.groupSchedules
		);

		setEvents([
			...masters,    // ✅ KEEP MASTER
			...expanded    // ✅ ADD CHILD EVENTS
		]);
	}, [props?.parkinglotObj]);


	const expandGroupSchedules = (groupSchedules = []) => {
		const events = [];

		groupSchedules.forEach(group => {
			const groupName = group.groupName || "Default";

			(group.schedules || []).forEach(sch => {
				if (!sch.isMaster) return;

				const baseStart = new Date(sch.start);
				const baseEnd = new Date(sch.end);
				const duration = baseEnd - baseStart;
				if (duration <= 0) return;

				const isCustom = sch.recurrence === "custom";
				const hasSelectedDays =
					Array.isArray(sch.selectedDays) && sch.selectedDays.length > 0;

				/* 🔹 SINGLE DAY */
				const isSingleDayEvent =
					!sch.recurrence ||
					(isCustom &&
						sch.customRecurrenceType === "week" &&
						sch.customRecurrenceCount === 1 &&
						!hasSelectedDays);

				/* 🔹 END LIMIT */
				let endLimit;
				if (isSingleDayEvent) {
					endLimit = new Date(baseStart);
				} else if (sch.endType === "on" && sch.endDateOn) {
					endLimit = new Date(sch.endDateOn);
				} else {
					endLimit = new Date(baseStart);
					endLimit.setFullYear(endLimit.getFullYear() + 1);
				}

				let current = new Date(baseStart);

				while (current <= endLimit) {
					const dayName = current.toLocaleDateString("en-US", {
						weekday: "short"
					});

					/* 🔹 selectedDays filter */
					if (hasSelectedDays && !sch.selectedDays.includes(dayName)) {
						current.setDate(current.getDate() + 1);
						continue;
					}

					events.push({
						...sch,
						id: `${sch.id}_${current.toISOString()}`,
						recurrenceId: sch.id,
						start: new Date(current),
						end: new Date(current.getTime() + duration),
						isMaster: false,
						groupName
					});

					/* 🔥 MOVE CORRECTLY */
					if (hasSelectedDays) {
						current.setDate(current.getDate() + 1);
					}
					else if (isCustom) {
						switch (sch.customRecurrenceType) {
							case "week":
								current.setDate(current.getDate() + 7);
								break;
							case "month":
								current.setMonth(
									current.getMonth() + (sch.customRecurrenceCount || 1)
								);
								break;
							case "year":
								current.setFullYear(
									current.getFullYear() + (sch.customRecurrenceCount || 1)
								);
								break;
							default:
								current.setDate(current.getDate() + 1);
						}
					}
					else {
						switch (sch.recurrence) {
							case "weekly":
								current.setDate(current.getDate() + 7);
								break;
							case "bi-weekly":
								current.setDate(current.getDate() + 14);
								break;
							case "monthly":
								current.setMonth(current.getMonth() + 1);
								break;
							case "yearly":
								current.setFullYear(current.getFullYear() + 1);
								break;
							default:
								current.setDate(current.getDate() + 1);
						}
					}
				}
			});
		});

		return events;
	};

	useEffect(() => {
		if (!events || events.length === 0) return;

		const uniquePslNames = [
			...new Set(events.map((ev) => ev.pslName).filter(Boolean)),
		];

		setUpdatepslNames(uniquePslNames);

	}, [events]);

	useEffect(() => {
		const isDuplicate = (addressvalue || props.defaultaddress) && parkingLotBookingDetails?.some((p) => p.parkingLotAddress.trim().toLowerCase() ===
			(addressvalue || props.defaultaddress).trim().toLowerCase());
		if (isDuplicate) {
			setDuplicateAddressError(true);
			return;
		} else {
			setDuplicateAddressError(false);
		}
	}, [issearchdisabled, addressvalue, parkingLotBookingDetails])

	// const logEvents = () => {

	// };

	let currentMarker = useRef();
	const [timeValues, setTimeValues] = useState(props?.parkinglotObj?.scheduleavailability?.timeSlot || {
		Monday: "",
		Tuesday: "",
		Wednesday: "",
		Thursday: "",
		Friday: "",
		Saturday: "",
		Sunday: "",
	});

	const [markingalert, setMarkingalert] = useState(false);
	const [conditions1, setStepParkOnly] = useState({
		"1 of 5 - Locate your Property": true,
		"2 of 5 - Mark Parking Spaces": false,
		"3 of 5 - Schedule Availability": false,
		"4 of 5 - Enter Bank Details": false,
		"5 of 5 - Review and Confirm": false,
	});
	const [conditions, setConditions] = useState({
		"1 of 6 - Locate your Property": true,
		"2 of 6 - Mark Parking Spaces": false,
		"3 of 6 - Pick ups and  Drop offs": false,
		"4 of 6 - Schedule Availability": false,
		"5 of 6 - Enter Bank Details": false,
		"6 of 6 - Review and Confirm": false,
	});
	const [latitude, setLatitude] = useState(null);
	const [longitude, setLongitude] = useState(null);
	const [enableMarker, setEnablemarker] = useState(false);
	const [bankdetails, setBankdetails] = useState(false);
	const [reviewlocation, setReviewlocation] = useState(false);
	const [errorsbank, setbankErrors] = useState({});
	const navigate = useNavigate();
	const [isautoSave, setAutosave] = useState(false);
	const [isSaveDisabled, setIsSaveDisabled] = useState(false);
	const [accountinfo, setAccountinfo] = useState({
		BankName: bankaccountdetails ? bankaccountdetails.bankName : "",
		AccountHolderName: bankaccountdetails ? bankaccountdetails.accountHolderName : "",
		AccountType: bankaccountdetails ? bankaccountdetails.accountType : "",
		AccountNumber: bankaccountdetails ? bankaccountdetails.accountNumber : "",
		RoutingNumber: bankaccountdetails ? bankaccountdetails.routingNumber : "",
		SWIFT_BIC_Code: bankaccountdetails ? bankaccountdetails.swifT_BIC_Code : "",
	});

	const handleDatePickerChange = (date) => {
		setSelectedDate(date);
	};

	const lastSavedStateRef = useRef({
		addressvalue: '',
		areasMarked: props.areasMarked || [],
		timeValues: props?.parkinglotObj?.scheduleavailability?.timeSlot || timeValues,
		accountinfo: { ...accountinfo }
	});

	const handleCheckNickName = (PropertyNickName, oldNickName) => {
		return PropertyNickName !== oldNickName;
	};

	useEffect(() => {
		// Use business areas (without blue pin) for save logic
		const businessAreas = getBusinessAreasMarked();

		const isDisabled = (addressvalue.length >= 0 && PropertyNickName.length === 0 && businessAreas.length === 0) ||
			(events?.length === 0 && scheduleavailability && PropertyNickName === undefined) ||
			(duplicateAddressError && !issearchdisabled) ||
			(addressvalue === lastSavedStateRef?.current?.addressvalue &&
				JSON.stringify(businessAreas) === JSON.stringify(lastSavedStateRef.current.areasMarked)
				&& JSON.stringify(accountinfo) === JSON.stringify(lastSavedStateRef.current.accountinfo)
				&& JSON.stringify(timeValues) === JSON.stringify(lastSavedStateRef.current.timeValues)
				&& JSON.stringify(PropertyNickName) === JSON.stringify(lastSavedStateRef.current.nickName));

		setIsSaveDisabled(businessAreas.length === 0 && issearchdisabled ? true : isDisabled);

		if (handleCheckNickName(PropertyNickName, oldNickName)) {
			setNickNameStatus(true);
		}
	}, [addressvalue, areasMarked, scheduleavailability, accountinfo, timeValues, events, issearchdisabled, PropertyNickName, duplicateAddressError])

	const isAnyValueAbove100 = Object.values(areas).some(value => value >= 100);
	const minWidthStyle = isAnyValueAbove100 ? '30px' : '20px';
	const stateLogedInUser = (props?.userData?.emailId) ? (props?.userData?.emailId) : (props?.employeeData?.emailId);
	const createdBy = (props.empId) ? props.verifiedBy : ((props?.userData?.firstName) ? (props?.userData?.firstName) : (props?.employeeData?.firstName))
	const registrationId = props?.userData?.entityRegistrationID || props?.employeeData?.ID;
	const accordionStyles = {
		marginTop: "14px",
		marginLeft: !scheduleavailability ? '0px' : '20px',
		flexGrow: !scheduleavailability ? 0 : 1
	};

	const validateTimeValues = () => {
		const newErrors = {};
		switch (selectedValue) {
			case 'WeekDays':
				['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'].forEach(day => {
					if (!timeValues[day]) newErrors[day] = `${day} is required.`;
				});
				break;
			case 'WeekEnd':
				['Saturday', 'Sunday'].forEach(day => {
					if (!timeValues[day]) newErrors[day] = `${day} is required.`;
				});
				break;
			case 'Custom':
				if (!Object.values(timeValues).some(value => value)) {
					newErrors.general = "At least one day must have a value.";
				}
				break;
			case 'WholeWeek':
				Object.keys(timeValues).forEach(day => {
					if (!timeValues[day]) newErrors[day] = `${day} is required.`;
				});
				break;
			default:
				break;
		}
		return Object.keys(newErrors).length === 0;
	};

	const handleSelectedBankDetailID = (bankDetailID) => {
		setSelectedBankDetailID(bankDetailID);
	};

	const handleInputChange = (e) => {
		const { name, value = "" } = e.target

		setAccountinfo((prevState) => ({
			...prevState,
			[name]: value,
		}));

		setPropertyNickName(value);

		const validateField = (fieldName, fieldValue, regex, emptyMessage, invalidMessage) => {
			if (fieldValue.trim() === "") {
				setbankErrors((errors) => ({ ...errors, [fieldName]: emptyMessage }));
			} else if (regex && !regex.test(fieldValue)) {
				setbankErrors((errors) => ({ ...errors, [fieldName]: invalidMessage }));
			} else {
				setbankErrors((errors) => ({ ...errors, [fieldName]: "" }));
			}
		};

		switch (name) {
			case 'BankName':
				validateField(name, value, /^[a-zA-Z\s]*$/, '', 'Please enter alphabets only');
				break;
			case 'AccountHolderName':
				validateField(name, value, /^[a-zA-Z\s]*$/, '', 'Please enter alphabets only');
				break;
			case 'AccountType':
				validateField(name, value, /^[A-Za-z\s()]+$/, '', 'Please check the Account Type format');
				break;
			case 'AccountNumber':
				validateField(name, value, /^\d{8,12}$/, '', 'Account Number must be between 8 and 12 digits');
				break;
			case 'RoutingNumber':
				validateField(name, value, /^\d{9}$/, '', 'Routing Number must be exactly 9 digits');
				break;
			case 'SWIFT_BIC_Code':
				break;
			default:
				break;
		}
	};

	const handleCancelalert = (val) => {
		setMarkingalert(val);
	};

	const resetStates = (step = 1) => {
		setExpanded(false);
		setFrame1Open(false);
		setConfirmAddress(false);
		setConfirmforScheduleAvailability(true);
		setSearchValue('');
		setSuggestions([]);
		setSearchError(false);
		setSearchdisabled(false);
		setAddressvalue('');
		setSelectedOption([]);
		setareasmarked(areasMarked);
		setscheduleavailability(false);
		// resetGroupsToDefault();
		setSelectedValue('');
		setAlertpopup(false);
		setOptionerror(false);
		setOnlyPark(false);
		setMarkOption(false);
		setTimeValues({
			Monday: "", Tuesday: "", Wednesday: "",
			Thursday: "", Friday: "", Saturday: "", Sunday: "",
		});
		setConditions({
			"1 of 6 - Locate your Property": true,
			"2 of 6 - Mark Parking Spaces": false,
			"3 of 6 - Pick ups and  Drop offs": false,
			"4 of 6 - Schedule Availability": false,
			"5 of 6 - Enter Bank Details": false,
			"6 of 6 - Review and Confirm": false,
		});
		setStepParkOnly({
			"1 of 5 - Locate your Property": true,
			"2 of 5 - Mark Parking Spaces": false,
			"3 of 5 - Schedule Availability": false,
			"4 of 5 - Enter Bank Details": false,
			"5 of 5 - Review and Confirm": false,
		})
		setEnablemarker(false);
		setBankdetails(false);
		setReviewlocation(false);
		setbankErrors({});
		setMarkingalert(false);
		setShowPickUPSDropoffs(false);
		setCurrentStep(step);
		setshowParkOnly(true);




	};

	const validateFields = () => {
		let tempErrors = {};
		let isValid = true;
		const validateField = (field, value, regex, emptyMessage, invalidMessage) => {
			if (regex && !regex.test(value) && value?.length > 0) {
				tempErrors[field] = invalidMessage;
				isValid = false;
			}
		};
		validateField('BankName', accountinfo.BankName, /^[A-Za-z\s]+$/, 'Bank Name is required', 'Please enter alphabets only');
		validateField('AccountHolderName', accountinfo.AccountHolderName, /^[A-Za-z\s]+$/, 'Account Holder Name is required', 'Please enter alphabets only');
		validateField('AccountNumber', accountinfo.AccountNumber, /^\d{8,12}$/, 'Account Number is required', 'Account Number must be between 8 and 12 digits');
		validateField('RoutingNumber', accountinfo.RoutingNumber, /^\d{9}$/, 'Routing Number is required', 'Routing Number must be exactly 9 digits');
		validateField('AccountType', accountinfo.AccountType, /^[A-Za-z\s()]+$/, 'Account Type is required', 'Please Check the Account Type Format');
		setbankErrors(tempErrors);
		return isValid;
	};

	const handleReview = (val) => {
		setReviewlocation(val);
		if (onlyPark) {
			setStepParkOnly({
				"1 of 5 - Locate your Property": false,
				"2 of 5 - Mark Parking Spaces": false,
				"3 of 5 - Schedule Availability": false,
				"4 of 5 - Enter Bank Details": false,
				"5 of 5 - Review and Confirm": true,
			})
		} else {
			setConditions({
				"1 of 6 - Locate your Property": false,
				"2 of 6 - Mark Parking Spaces": false,
				"3 of 6 - Pick ups and  Drop offs": false,
				"4 of 6 - Schedule Availability": false,
				"5 of 6 - Enter Bank Details": false,
				"6 of 6 - Review and Confirm": true,
			});
		}
	}

	const backToBankdetails = () => {
		if (onlyPark) {
			setStepParkOnly({
				"1 of 5 - Locate your Property": false,
				"2 of 5 - Mark Parking Spaces": false,
				"3 of 5 - Schedule Availability": false,
				"4 of 5 - Enter Bank Details": true,
				"5 of 5 - Review and Confirm": false,
			})
		} else {
			setConditions({
				"1 of 6 - Locate your Property": false,
				"2 of 6 - Mark Parking Spaces": false,
				"3 of 6 - Pick ups and  Drop offs": false,
				"4 of 6 - Schedule Availability": false,
				"5 of 6 - Enter Bank Details": true,
				"6 of 6 - Review and Confirm": false,
			});
		}
	}

	const timeSlotesAvailability = () => {
		if (validateTimeValues()) {
			setBankdetails(true);
			if (onlyPark) {
				setStepParkOnly({
					"1 of 5 - Locate your Property": false,
					"2 of 5 - Mark Parking Spaces": false,
					"3 of 5 - Schedule Availability": false,
					"4 of 5 - Enter Bank Details": true,
					"5 of 5 - Review and Confirm": false,
				})
			} else {
				setConditions({
					"1 of 6 - Locate your Property": false,
					"2 of 6 - Mark Parking Spaces": false,
					"3 of 6 - Pick ups and  Drop offs": false,
					"4 of 6 - Schedule Availability": false,
					"5 of 6 - Enter Bank Details": true,
					"6 of 6 - Review and Confirm": false,
				});
			}
			toggleCondition('4 of 5 - Enter Bank Details')
			toggleCondition('3 of 5 - Schedule Availability')
		}
	}

	useEffect(() => {
		if (weekoption === '') {
			setTimeValues({
				Monday: "",
				Tuesday: "",
				Wednesday: "",
				Thursday: "",
				Friday: "",
				Saturday: "",
				Sunday: "",
			});
		}
	}, [selectedValue]);

	const handlebankdetails = (val) => {
		setBankdetails(val);
		if (onlyPark) {
			setStepParkOnly({
				"1 of 5 - Locate your Property": false,
				"2 of 5 - Mark Parking Spaces": false,
				"3 of 5 - Schedule Availability": true,
				"4 of 5 - Enter Bank Details": false,
				"5 of 5 - Review and Confirm": false,
			})
		} else {
			setConditions({
				"1 of 6 - Locate your Property": false,
				"2 of 6 - Mark Parking Spaces": false,
				"3 of 6 - Pick ups and  Drop offs": false,
				"4 of 6 - Schedule Availability": true,
				"5 of 6 - Enter Bank Details": false,
				"6 of 6 - Review and Confirm": false,
			});
		}
	}

	const handleselectedOption = (area) => {
		setEnablemarker(true);
		markerEnabled.current = true;
		setSelectedOption(area);
		setOptionerror(false);
	}

	const openFrame = useCallback(() => {
		setFrameOpen(true);
	}, []);

	const closeFrame = () => {
		setFrameOpen(false);
	};


	const nextBtn = () => {
		const businessAreas = getBusinessAreasMarked();
		const hasPSLEntry = businessAreas.some(area => area.Name === 'PSL - Parking Space Location');

		if ((businessAreas?.length > 0 && !hasPSLEntry) || (businessAreas.length === 0 && !hasPSLEntry)) {
			handleCancelalert(true);
			return;
		}

		if (businessAreas.length > 0 && hasPSLEntry) {
			setConfirmforScheduleAvailability(true);
			setFrame1Open(true);
		}

		if (!PropertyNickName.trim()) {

			toast.error("Please enter a property nickname", {
				toastId: "nicknameError",
				position: "top-right",
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
			});
			return;
		}

	}

	const openFrame1 = useCallback(() => {
		if (loader) {
			return;
		}
		// 1. Property nickname validation
		if (!PropertyNickName || !PropertyNickName.trim()) {
			toast.error("Please enter a property nickname", {
				toastId: "nicknameError",
				position: "top-right",
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: false,
			});
			return;
		}
		if (duplicateAddressError && !issearchdisabled) {
			toast.error("Property address already exists. Please enter a new address.", {
				toastId: "duplicateAddressError",
				position: "top-right",
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
			});
			return;
		}

		// 2. PSL spot size validation only - Use business areas (exclude blue pin)
		const businessAreas = getBusinessAreasMarked();

		// reset any pending PSL popup
		setShowSpotSizePopup(false);
		setPendingMarkerData(null);
		setSpotPopupPosition(null);
		unlockPopup();

		// 3. If address not confirmed, show address confirmation first
		if ((addressvalue || props.defaultaddress) && !isAddressSelected) {
			setFrame1Open(true);
			setConfirmAddress(true);
			setCurrentStep(2);
			return;
		}

		// 4. If address is already confirmed
		if (isAddressSelected) {
			setSelectedOption([]);
			setOptionerror(true);

			const hasPSLEntry = businessAreas?.some(
				(area) => area.Name === "PSL - Parking Space Location"
			);

			// No markers but search disabled
			if (businessAreas?.length === 0 && issearchdisabled) {
				setOptionerror(true);
				return;
			}

			// User selected something but no PSL marker present
			if (selectedOption?.length > 0 && (businessAreas?.length === 0 || !hasPSLEntry)) {
				handleCancelalert(true);
				return;
			}

			// At least one marker exists but PSL missing
			if (businessAreas?.length > 0 && !hasPSLEntry) {
				handleCancelalert(true);
				return;
			}

			// Only parking flow
			if (onlyPark && hasPSLEntry) {
				setscheduleavailability(true);
				setStepParkOnly({
					"1 of 5 - Locate your Property": false,
					"2 of 5 - Mark Parking Spaces": false,
					"3 of 5 - Schedule Availability": true,
					"4 of 5 - Enter Bank Details": false,
					"5 of 5 - Review and Confirm": false,
				});
				return;
			}

			// Parking + RoboTaxi flow
			if (!onlyPark) {
				setshowParkOnly(false);
				setShowPickUPSDropoffs(true);
				setCurrentStep(3);
				setRoboTaxiPopup(false);
				setConditions({
					"1 of 6 - Locate your Property": false,
					"2 of 6 - Mark Parking Spaces": false,
					"3 of 6 - Pick ups and  Drop offs": true,
					"4 of 6 - Schedule Availability": false,
					"5 of 6 - Enter Bank Details": false,
					"6 of 6 - Review and Confirm": false,
				});
				const area = props.area;
				handleselectedOption(area);
				if (RoboTaxis && selectedRoboTaxiOption) {
					setRoboTaxiPopup(false);
				}
			}
		}
	}, [
		showSpotSizePopup,
		pendingMarkerData,
		addressvalue,
		props.defaultaddress,
		isAddressSelected,
		PropertyNickName,
		selectedOption,
		areasMarked,
		issearchdisabled,
		onlyPark,
		selectedRoboTaxiOption,
		RoboTaxis,
		duplicateAddressError
	]);

	const closeFrame1 = useCallback(() => {
		const businessAreas = getBusinessAreasMarked();
		if (businessAreas.length > 0) {
			setFrame1Open(false);
			return;
		}
		setConditions({
			"1 of 6 - Locate your Property": true,
			"2 of 6 - Mark Parking Spaces": false,
			"3 of 6 - Pick ups and  Drop offs": false,
			"4 of 6 - Schedule Availability": false,
			"5 of 6 - Enter Bank Details": false,
			"6 of 6 - Review and Confirm": false,
		});
		setFrame1Open(false);
		setConfirmAddress(false);
		setAlertpopup(false);
	}, [areasMarked]);

	const closeaddressReset = useCallback(() => {
		setFrame1Open(false);
		setAlertpopup(false);
	}, []);

	function attachMarkerHoverEvents(markerElement) {
		markerElement.addEventListener("mouseover", () => {
			const card = markerElement.querySelector(".marker-card");
			if (card) card.style.display = "flex";
		});

		markerElement.addEventListener("mouseout", () => {
			const card = markerElement.querySelector(".marker-card");
			if (card) card.style.display = "none";
		});
	}

	const handleContinue = () => {
		const businessAreas = getBusinessAreasMarked();
		if (businessAreas.length > 0 && showPickUPSDropoffs) {
			setscheduleavailability(true)
			setConditions({
				"1 of 6 - Locate your Property": false,
				"2 of 6 - Mark Parking Spaces": false,
				"3 of 6 - Pick ups and  Drop offs": false,
				"4 of 6 - Schedule Availability": true,
				"5 of 6 - Enter Bank Details": false,
				"6 of 6 - Review and Confirm": false,
			});
			setExpanded(true)
			setFrame1Open(false);
			setAlertpopup(false);
		}
		else {
			setFrameOpen(true)
			setSearchdisabled(true);
			setCurrentStep(2);
			setFrame1Open(false);
			setAlertpopup(false);
			setConditions({
				"1 of 6 - Locate your Property": false,
				"2 of 6 - Mark Parking Spaces": true,
				"3 of 6 - Pick ups and  Drop offs": false,
				"4 of 6 - Schedule Availability": false,
				"5 of 6 - Enter Bank Details": false,
				"6 of 6 - Review and Confirm": false,
			});
		}
	}

	const handleConfirm = (val) => {
		setscheduleavailability(val);
		if (onlyPark) {
			setStepParkOnly({
				"1 of 5 - Locate your Property": false,
				"2 of 5 - Mark Parking Spaces": true,
				"3 of 5 - Schedule Availability": false,
				"4 of 5 - Enter Bank Details": false,
				"5 of 5 - Review and Confirm": false,
			})
		}
		else {
			setConditions({
				"1 of 6 - Locate your Property": false,
				"2 of 6 - Mark Parking Spaces": false,
				"3 of 6 - Pick ups and  Drop offs": true,
				"4 of 6 - Schedule Availability": false,
				"5 of 6 - Enter Bank Details": false,
				"6 of 6 - Review and Confirm": false,
			});
		}
	}

	let markers = []; // Array to store all markers
	const selectedOptionRef = useRef(selectedOption);

	useEffect(() => {
		selectedOptionRef.current = selectedOption;
	}, [selectedOption]);

	// NEW: Function to add/remove blue pin separately
	const addBluePinMarker = (latitude, longitude) => {
		// Remove existing blue pin if it exists
		if (bluePinRef.current && mapRef.current) {
			mapRef.current.markers.remove(bluePinRef.current);
			bluePinRef.current = null;
		}

		if (!mapRef.current) return;

		const img = document.createElement('img');
		img.src = '/icons/blue-pin.png';
		img.style.width = '80px';
		img.style.height = '130px';
		img.style.objectFit = 'contain';
		img.style.cursor = 'pointer';

		const bluePinMarker = new atlas.HtmlMarker({
			position: [longitude, latitude],
			htmlContent: img,
			anchor: "bottom",
		});

		mapRef.current.markers.add(bluePinMarker);
		bluePinRef.current = bluePinMarker;
		setBluePinMarker({
			id: "searched-location-pin",
			Name: "Searched Location",
			Coordinates: {
				Latitude: latitude,
				Longitude: longitude,
			}
		});
	};

	useEffect(() => {
		const initializeMap = () => {
			let mapElement = document.getElementById('myMap');
			if (mapElement) {
				map = new atlas.Map('myMap', {
					center: [longitude || -122.18402494821507, latitude || 47.61373420362662],
					zoom: 18,
					language: 'en-US',
					style: 'satellite',
					authOptions: {
						authType: 'subscriptionKey',
						subscriptionKey: 'EN5vcaicwC78zKi3M3980VVB1m7DuuN0vKaDMtYdjBg7daKhx3OTJQQJ99AHAC8vTIngVrqvAAAgAZMPLtXG'
					}
				});
				mapRef.current = map;
				if (map && map.events && typeof map.events.add === 'function') {
					map.events.add('ready', function () {
						const zoomControl = new atlas.control.ZoomControl();
						if (map.controls && typeof map.controls.add === 'function') {
							map.controls.add(zoomControl, {
								position: 'bottom-right'
							});
						}
					});
				};
			}
		}
		if (latitude && longitude) {
			initializeMap();
			InitMap();
		}
	}, [latitude, longitude, scheduleavailability, props.areasMarked, onlyPark, showPickUPSDropoffs]);

	const getColorForText = (text) => {
		const colorMap = {
			"PSL - Parking Space Location": "#006400", 
			"PKE - Parking Entrance": "#f48506bc", 
			"PKX - Parking Exit": "#bdf407",
			"PUE - Pick Up Entrance": "#FFD700",
			"PUL - Pick Up Location": "rgba(255, 0, 0, 0.66)",
			"PUX - Pick Up Exit": "#f40bae66", 
			"DOE - Drop Off Entrance": "#a305f3", 
			"DOL - Drop Off Location": "#5b08f6b6", 
			"DOX - Drop Off Exit": "#0bbaef", 
		};
		return colorMap[text];
	};

	const isColorDark = (color) => {
		const hex = color?.replace("#", "");
		const r = parseInt(hex?.substring(0, 2), 16);
		const g = parseInt(hex?.substring(2, 4), 16);
		const b = parseInt(hex?.substring(4, 6), 16);
		// Calculate brightness (YIQ color model)
		return ((r * 299 + g * 587 + b * 114) / 1000) < 128;
	};

	// ✅ FIX 1: Update the useEffect that re-renders markers when areasMarked changes
	useEffect(() => {

		if (!mapRef.current) return;

		//---------------------------------------------------------
		// 1. Remove markers that no longer exist in state
		//---------------------------------------------------------
		Object.keys(markerMap.current).forEach(markerId => {
			const existsInState = areasMarked.some(m => m.id.toString() === markerId.toString());
			if (!existsInState) {
				const marker = markerMap.current[markerId];
				mapRef.current.markers.remove(marker);
				htmlMarkers.current = htmlMarkers.current.filter(m => m !== marker);
				delete markerMap.current[markerId];
			}
		});


		//---------------------------------------------------------
		// 2. Loop through state and update or create markers
		//---------------------------------------------------------
		areasMarked.forEach(m => {

			//---------------------------------------------------------
			// CASE A: Marker already exists -> just refresh content
			//---------------------------------------------------------
			if (markerMap.current[m.id]) {

				const existingMarker = markerMap.current[m.id];
				const elem = existingMarker.getElement();

				const html = createMarkerHTMLContent(
					m.Name,
					m.Coordinates.Latitude,
					m.Coordinates.Longitude,
					m.VehicleSpotSize,
					m.pslName,
					m.groupName
				);

				elem.innerHTML = html;

				const closeBtn = elem.querySelector(".marker-close-button");
				if (closeBtn) {

					const canDelete = canDeleteInCurrentStep(m.Name);
					if (canDelete) {
						closeBtn.onclick = (e) => {

							if (!canDeleteInCurrentStep(m.Name)) {
								e.stopPropagation();
								return;
							}
							mapRef.current.markers.remove(existingMarker);
							delete markerMap.current[m.id];

							setareasmarked(prev => {
								let updated = prev.filter(mm => mm.id !== m.id);

								// 🔥 Reorder remaining PSL after delete
								const psl = updated
									.filter(x => x.Name === "PSL - Parking Space Location")
									.sort((a, b) => a.id - b.id);

								psl.forEach((x, i) => x.pslName = `PSL${i + 1}`);

								return [...updated];
							});

							e.stopPropagation();
						};
						closeBtn.style.cursor = 'pointer';
						const deleteImg = closeBtn.querySelector('img');
						if (deleteImg) {
							deleteImg.style.opacity = '1';
						}
						// closeBtn.style.opacity = '1';
					} else {
						closeBtn.onclick = (e) => {
							if (!canDeleteInCurrentStep(m.Name)) {
								e.stopPropagation();
								return;
							}
							if (currentStep === 2) {
								// toast.warn("This marker type can only be deleted in 'Pick ups and Drop offs' step.");
							} else if (currentStep === 3) {
								// toast.warn("This marker type can only be deleted in 'Mark Parking Spaces' step.");
							} else {
								//  toast.warn("Markers cannot be deleted in this step. Please go back to the marking steps.");
							}
							e.stopPropagation();
						};

						closeBtn.style.cursor = 'not-allowed';
						const deleteImg = closeBtn.querySelector('img');
						if (deleteImg) {
							deleteImg.style.opacity = '0.3';
						}
						//        closeBtn.style.opacity = '0.5';

					}
				}

			}

			//---------------------------------------------------------
			// CASE B: New marker -> create and attach events
			//---------------------------------------------------------
			else {

				const htmlContent = createMarkerHTMLContent(
					m.Name,
					m.Coordinates.Latitude,
					m.Coordinates.Longitude,
					m.VehicleSpotSize,
					m.pslName,
					m.groupName
				);

				const marker = new atlas.HtmlMarker({
					htmlContent,
					position: [m.Coordinates.Longitude, m.Coordinates.Latitude],
					anchor: "bottom",
					draggable: currentStep === 2
				});

				mapRef.current.markers.add(marker);
				markerMap.current[m.id] = marker;

				const elem = marker.getElement();

				// drag event
				mapRef.current.events.add("dragend", marker, () => {
					if (currentStep !== 2) return;
					const pos = marker.getOptions().position;
					setareasmarked(prev =>
						prev.map(mm =>
							mm.id === m.id
								? { ...mm, Coordinates: { Latitude: pos[1], Longitude: pos[0] } }
								: mm
						)
					);
				});

				// delete event
				const closeBtn = elem.querySelector(".marker-close-button");

				if (closeBtn) {
					const canDelete = canDeleteInCurrentStep(m.Name);

					// 🔥 Clone safely to remove old handlers
					const newCloseBtn = closeBtn.cloneNode(true);
					closeBtn.parentNode.replaceChild(newCloseBtn, closeBtn);

					if (canDelete) {
						newCloseBtn.onclick = (e) => {
							e.stopPropagation();

							if (!canDeleteInCurrentStep(m.Name)) return;

							const existingMarker = markerMap.current[m.id];
							if (existingMarker) {
								mapRef.current.markers.remove(existingMarker);
								delete markerMap.current[m.id];
							}

							setareasmarked(prev => {
								const updated = prev.filter(mm => mm.id !== m.id);

								// Reorder PSL numbers
								const psl = updated
									.filter(x => x.Name === "PSL - Parking Space Location")
									.sort((a, b) => a.id - b.id);

								psl.forEach((x, i) => (x.pslName = `PSL${i + 1}`));

								return [...updated];
							});
						};

						newCloseBtn.style.cursor = "pointer";
						const img = newCloseBtn.querySelector("img");
						if (img) img.style.opacity = "1";
					} else {
						newCloseBtn.onclick = (e) => e.stopPropagation();
						newCloseBtn.style.cursor = "not-allowed";
						const img = newCloseBtn.querySelector("img");
						if (img) img.style.opacity = "0.3";
					}
				}

			}
		});


		//---------------------------------------------------------
		// 3. Update counts (PSL/PKE/PKX etc.)
		//---------------------------------------------------------
		const areaCount = {
			"PSL - Parking Space Location": 0,
			"PKE - Parking Entrance": 0,
			"PKX - Parking Exit": 0
		};

		const pickupDropoff = {
			"PUE - Pick Up Entrance": 0,
			"DOE - Drop Off Entrance": 0,
			"PUL - Pick Up Location": 0,
			"DOL - Drop Off Location": 0,
			"PUX - Pick Up Exit": 0,
			"DOX - Drop Off Exit": 0
		};

		areasMarked.forEach(m => {
			if (areaCount[m.Name] !== undefined) areaCount[m.Name]++;
			if (pickupDropoff[m.Name] !== undefined) pickupDropoff[m.Name]++;
		});

		setAreas(areaCount);
		setPickUPSDropoffs(pickupDropoff);

	}, [areasMarked, groups, currentStep]); // <== Automatic PSL reorder refresh

	const handleSpotSizeApply = ({ size }) => {
		if (!pendingMarkerData || !mapRef.current) return;

		const { latitude, longitude, optionText, id, markdata } = pendingMarkerData;

		// ✅ Preserve PSL1/PSL2 label
		const customName = markdata?.pslName || "";

		const updatedMarkData = {
			...markdata,
			VehicleSpotSize: size,
			pslName: customName,
			groupName: selectedGroup
		};

		if (markerMap.current[id]) {
			mapRef.current.markers.remove(markerMap.current[id]);
			htmlMarkers.current = htmlMarkers.current.filter(
				(m) => m !== markerMap.current[id]
			);
			delete markerMap.current[id];
		}

		// ✅ Create fresh marker with PSL label + size
		const markerElement = document.createElement("div");
		markerElement.innerHTML = createMarkerHTMLContent(
			optionText,
			latitude,
			longitude,
			// size,
			customName
		);

		const newMarker = new atlas.HtmlMarker({
			htmlContent: markerElement,
			position: [longitude, latitude],
			anchor: "bottom",
			draggable: currentStep === 2,
		});

		mapRef.current.markers.add(newMarker);
		markerMap.current[id] = newMarker;
		htmlMarkers.current.push(newMarker);
		attachMarkerHoverEvents(markerElement);

		// Drag update
		mapRef.current.events.add("dragend", newMarker, function () {
			const newPosition = newMarker.getOptions().position;
			const newLatitude = newPosition[1];
			const newLongitude = newPosition[0];
			setareasmarked((prev) =>
				prev.map((m) => {
					if (m.id === id) {
						return {
							...m,
							Coordinates: {
								...m.Coordinates,
								Latitude: newLatitude,
								Longitude: newLongitude,
							},
						};
					}
					return m;
				})
			);


			if (optionText === "PSL - Parking Space Location") {
				setShowSpotSizePopup(false);
				setSpotPopupPosition(null);
				setPendingMarkerData(null);
				unlockPopup();
			}
		});

		// Delete button
		const closeBtn = markerElement.querySelector(".marker-close-button");
		if (closeBtn) {
			closeBtn.addEventListener("click", (e) => {
				const canDelete = canDeleteInCurrentStep(optionText);
				if (!canDelete) {
					e.stopPropagation();
					return;
				}
				mapRef.current.markers.remove(newMarker);
				htmlMarkers.current = htmlMarkers.current.filter((m) => m !== newMarker);
				delete markerMap.current[id];

				setareasmarked((prev) => {
					const updated = prev.filter((m) => m.id !== id);

					const newAreas = { ...areas };
					const newPickupsDropoffs = { ...PickUPSDropoffs };
					Object.keys(newAreas).forEach((key) => (newAreas[key] = 0));
					Object.keys(newPickupsDropoffs).forEach((key) => (newPickupsDropoffs[key] = 0));

					updated.forEach((m) => {
						if (newAreas.hasOwnProperty(m.Name)) newAreas[m.Name]++;
						if (newPickupsDropoffs.hasOwnProperty(m.Name))
							newPickupsDropoffs[m.Name]++;
					});

					setAreas(newAreas);
					setPickUPSDropoffs(newPickupsDropoffs);

					return updated;
				});

				if (optionText === "PSL - Parking Space Location") {
					setShowSpotSizePopup(false);
					setPendingMarkerData(null);
					setSpotPopupPosition(null);
					unlockPopup();
				}

				e.stopPropagation();
			});
			const canDelete = canDeleteInCurrentStep(optionText);
			if (!canDelete) {
				closeBtn.style.cursor = 'not-allowed';
				closeBtn.style.opacity = '0.5';
			} else {
				closeBtn.style.cursor = 'pointer';
				closeBtn.style.opacity = '1';
			}
		}

		// Save marker data
		setareasmarked((prev) => {
			const filtered = prev.filter((m) => m.id !== id);
			return [...filtered, { ...updatedMarkData, VehicleSpotSize: size }];
		});

		// Update count safely
		setAreas((prev) => {
			const businessAreas = getBusinessAreasMarked();
			const newCount =
				(businessAreas.filter((m) => m.Name === optionText && m.id !== id).length ||
					0) + 1;
			return {
				...prev,
				[optionText]: newCount,
			};
		});

		setPendingMarkerData(null);
		setShowSpotSizePopup(false);
		unlockPopup();
	};

	const handleRoboTaxiCancel = () => {
		setRoboTaxiPopup(false);

		if (savedRoboTaxiPSLs.length === 0) {
			// ❗ nothing saved → uncheck
			setRoboTaxis(false);
			setSelectedRoboTaxiOption('');
			setDraftRoboTaxiPSLs([]);
			setSelectedPSLCheckboxes([]);
			setRoboTaxiLimit(0);
		} else {
			// restore saved state
			setDraftRoboTaxiPSLs([...savedRoboTaxiPSLs]);
			setSelectedPSLCheckboxes([...savedRoboTaxiPSLs]);
		}
	};


	// ✅ NEW: Re-sync markers when areasMarked changes (after drag)
	useEffect(() => {
		if (!mapRef.current || areasMarked.length === 0) return;

		// Update existing marker positions without recreating them
		areasMarked.forEach((area) => {
			const marker = markerMap.current[area.id];
			if (marker) {
				const currentPos = marker.getOptions().position;
				const newLat = area.Coordinates.Latitude;
				const newLon = area.Coordinates.Longitude;

				// Only update if position has changed
				if (currentPos[0] !== newLon || currentPos[1] !== newLat) {
					marker.setOptions({
						position: [newLon, newLat]
					});
				}
			}
		});
	}, [areasMarked]);

	const reorderPSL = (list) => {
		const pslItems = list
			.filter(x => x.Name === "PSL - Parking Space Location")
			.sort((a, b) => a.id - b.id);

		pslItems.forEach((item, index) => {
			item.pslName = `PSL${index + 1}`;
		});

		return list;
	};

	useEffect(() => {
		setareasmarked(prev => reorderPSL([...prev]));
	}, [areasMarked.length]);



	const createMarkerHTMLContent = (
		optionText,
		latitude,
		longitude,
		vehicleSize,
		customName = "",
		groupName = null   // ✅ NEW param
	) => {
		const isParkingLocation = (text) =>
			["PSL - Parking Space Location", "PKE - Parking Entrance", "PKX - Parking Exit"].includes(text);

		const isPickUpOrDropOff = (text) =>
			["PUE - Pick Up Entrance", "DOE - Drop Off Entrance", "PUL - Pick Up Location", "DOL - Drop Off Location", "PUX - Pick Up Exit", "DOX - Drop Off Exit"].includes(text);

		const isDraggable = !(showPickUPSDropoffs && isParkingLocation(optionText)) &&
			!(isPickUpOrDropOff(optionText) && !showPickUPSDropoffs);

		const text = typeof optionText === 'string' ? optionText : String(optionText);
		let color = getColorForText(text);

		// ✅ FIXED: Apply group color for PSL markers
		if (optionText === "PSL - Parking Space Location") {
			const targetGroup = groupName || selectedGroup;
			if (targetGroup) {
				const group = groups.find(g => g.name === targetGroup);
				if (group) {
					color = group.color;
				}
			}
		}
		const textColor = isColorDark(color) ? "white" : "black";
		const drag = "Drag to move, click to delete";



		return `
  <div class="marker-close-button" style="position: relative; width: 40px; height: 85px;" id="closeButton">
<!--
    ${vehicleSize ? `
      <div style="
        position: absolute;
        top: -11px;
        left: 118%;
        transform: translateX(-50%);
        background-color: white;
        color: black;
        padding: 2px 6px;
        border-radius: 4px;
        font-size: 10px;
        font-weight: bold;
        box-shadow: 0px 1px 4px rgba(0,0,0,0.3);
        white-space: nowrap;
      ">${vehicleSize}</div>` : ''}
	  --!>

    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="60" viewBox="0 0 24 36" fill="${color}">
      <path d="M12 0C5.383 0 0 5.383 0 12c0 7.188 10.83 22.812 10.83 22.812C11.147 34.81 12 34.365 12 34.365S12.853 34.81 13.17 34.812C13.17 34.812 24 19.188 24 12C24 5.383 18.617 0 12 0z"/>
      <text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="${textColor}" font-size="8">${text?.substring(0, 3)}</text>
    </svg>

    <!-- 🔹 New: show PSL1, PSL2, … if customName is provided -->
    ${customName ? `
      <div style="margin-top: -4px; font-size: 10px; font-weight: bold; background-color: white; color: black; padding: 2px 6px;
                    border-radius: 4px;
                  text-align: center; box-shadow: 0px 1px 4px rgba(0,0,0,0.3); white-space: nowrap;">
        ${customName}
      </div>` : ''}

    <div class="${isDraggable ? "marker-card marker" : "marker-card marker ristrictedmarker"}">
      ${isDraggable ? `
      <div id="closeButton" style="
        position: absolute;
        top: 5px;
        right: 5px;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: black;
        cursor: pointer;">
        <img className="icround-gps-fixed-icon" alt="Delete" src="Delete.png" style="width: 100%; height: 100%;" />
      </div>` : ''}

      <div style="font-size: 12px; color: black; margin-bottom: 8px;">
        ${text}<br />
        ${(currentStep === 2 && isParkingLocation(text)) ||
				(currentStep === 3 && isPickUpOrDropOff(text))
				? drag
				: ''
			} 
      </div>
    </div>
  </div>`;
	};


	const lockPopup = () => {
		isPopupLockedRef.current = true;
		setIsPopupLocked(true);
	};

	const unlockPopup = () => {
		isPopupLockedRef.current = false;
		setIsPopupLocked(false);
	};

	const addMarker = (
		latitude,
		longitude,
		optionText,
		id,
		fromRestore = false,
		vehicleSize,
		existingPslName = null,
		groupName = null
	) => {

		if (optionText === "Searched Location") {
			addBluePinMarker(latitude, longitude);
			return;
		}

		// Remove old marker instance
		if (markerMap.current[id]) {
			mapRef.current.markers.remove(markerMap.current[id]);
			htmlMarkers.current = htmlMarkers.current.filter(m => m !== markerMap.current[id]);
			delete markerMap.current[id];
		}

		// Validate
		if (!optionText || typeof optionText !== "string") return;
		if (isNaN(latitude) || isNaN(longitude)) return;

		// ---------------------------
		// GROUP HANDLING
		// ---------------------------
		let markerGroup = groupName;
		if (optionText === "PSL - Parking Space Location") {
			if (!fromRestore && !groupName) {
				markerGroup = selectedGroup || "Default";
			} else if (fromRestore && !groupName) {
				markerGroup = "Default";
			}
		}

		// ---------------------------
		// PSL NAME LOGIC
		// ---------------------------
		let customName = existingPslName || "";
		if (optionText === "PSL - Parking Space Location" && !fromRestore && !existingPslName) {
			pslCounterRef.current += 1;
			customName = `PSL${pslCounterRef.current}`;
		}

		const htmlContent = createMarkerHTMLContent(
			optionText,
			latitude,
			longitude,
			vehicleSize,
			customName,
			markerGroup
		);

		const isParkingLocation = (text) =>
			["PSL - Parking Space Location", "PKE - Parking Entrance", "PKX - Parking Exit"].includes(text);

		const isPickUpOrDropOff = (text) =>
			["PUE - Pick Up Entrance", "DOE - Drop Off Entrance", "PUL - Pick Up Location", "DOL - Drop Off Location", "PUX - Pick Up Exit", "DOX - Drop Off Exit"].includes(text);

		const isDraggable =
			!(showPickUPSDropoffs && isParkingLocation(optionText)) &&
			!(isPickUpOrDropOff(optionText) && !showPickUPSDropoffs);

		// ---------------------------
		// CREATE MARKER
		// ---------------------------
		const marker = new atlas.HtmlMarker({
			draggable: isDraggable,
			position: [longitude, latitude],
			htmlContent,
			anchor: "bottom",
		});

		// Don't allow wrong type unless restoring
		if (
			!fromRestore &&
			(
				(!showPickUPSDropoffs && isPickUpOrDropOff(optionText)) ||
				(showPickUPSDropoffs && isParkingLocation(optionText))
			)
		) {
			return;
		}

		// Add marker to map
		mapRef.current.markers.add(marker);
		htmlMarkers.current.push(marker);
		markerMap.current[id] = marker;   // ✅ FIXED (NO currentId error)

		const markerElement = marker.getElement();
		markerElement?.setAttribute("data-option-text", optionText);
		const closeButton = markerElement?.querySelector("#closeButton");

		// ---------------------------
		// DELETE HANDLER
		// ---------------------------
		if (closeButton) {
			attachMarkerHoverEvents(markerElement);

			closeButton.addEventListener("click", function (e) {

				const canDelete = canDeleteInCurrentStep(optionText);

				if (!canDelete) {
					e.stopPropagation();
					return;
				}
				mapRef.current.markers.remove(marker);
				htmlMarkers.current = htmlMarkers.current.filter(m => m !== marker);
				delete markerMap.current[id];

				// 🔥 Auto-Reorder PSL After Delete
				setareasmarked(prev => {
					const removed = prev.filter(m => m.id !== id);
					return reorderPSL(removed);
				});

				setPendingMarkerData(null);
				setShowSpotSizePopup(false);
				setSpotPopupPosition(null);
				unlockPopup();
				e.stopPropagation();
			});

			const canDelete = canDeleteInCurrentStep(optionText);
			if (!canDelete) {
				closeButton.style.cursor = 'not-allowed';
				// ✅ Only dim the delete icon image
				const deleteImg = closeButton.querySelector('img');
				if (deleteImg) {
					deleteImg.style.opacity = '0.3';
				}
			} else {
				closeButton.style.cursor = 'pointer';
				// ✅ Keep delete icon fully visible
				const deleteImg = closeButton.querySelector('img');
				if (deleteImg) {
					deleteImg.style.opacity = '1';
				}
			}
		}

		// ---------------------------
		// DRAG HANDLER
		// ---------------------------
		mapRef.current.events.add("dragend", marker, () => {
			//if (currentStep !== 2) return;
			const pos = marker.getOptions().position;
			const newLat = pos[1];
			const newLng = pos[0];

			setareasmarked(prev =>
				prev.map(m => {
					if (m.id !== id) return m;

					return {
						...m,
						Coordinates: {
							Title: m.Coordinates?.Title || m.Name,   // 🔥 THIS FIXES PUE / DOE / etc
							Latitude: newLat,
							Longitude: newLng
						}
					};
				})
			);

			setShowSpotSizePopup(false);
			setPendingMarkerData(null);
			unlockPopup();
		});

		// ---------------------------
		// MARKER DATA
		// ---------------------------
		const markdata = {
			id,
			Name: optionText,
			title: optionText,
			Coordinates: {
				Title: optionText,
				Latitude: latitude,
				Longitude: longitude,
			},
			latandlong: `Latitude: ${latitude} Longitude: ${longitude}`,
			pslName: customName,
			groupName: markerGroup,
			VehicleSpotSize:
				optionText === "PSL - Parking Space Location"
					? (vehicleSize || "Medium")
					: vehicleSize
		};

		const isInState = areasMarked.some(
			m =>
				m.id === id ||
				(m.Coordinates.Latitude === latitude &&
					m.Coordinates.Longitude === longitude &&
					m.Name === optionText)
		);

		// ---------------------------
		// PSL LOGIC
		// ---------------------------
		if (optionText === "PSL - Parking Space Location") {
			setPendingMarkerData({ latitude, longitude, optionText, id, markdata });

			if (fromRestore) {
				setShowSpotSizePopup(true);
				handleSpotSizeApply("Small");
				unlockPopup();

				// 🔥 Reorder PSL After Restore
				setareasmarked(prev => reorderPSL(prev));
				return;
			}

			// 🔥 Reorder PSL Immediately After New PSL Add
			setareasmarked(prev => reorderPSL(prev));

			// Show size popup
			if (markerElement) {
				const rect = markerElement.getBoundingClientRect();
				const popupX = rect.left + rect.width / 2 - 150;
				const popupY = rect.bottom + 10;

				setSpotPopupPosition({ x: popupX, y: popupY });
				setShowSpotSizePopup(true);
				setAutoApplySize({ size: "Small" });
				lockPopup();
			}

			return;
		}

		// ---------------------------
		// NON-PSL MARKER LOGIC
		// ---------------------------
		if (!isInState) {
			setareasmarked(prev => {
				const updated = [...prev, markdata];
				return reorderPSL(updated);   // 🔥 PSL Sequence Always Correct
			});
		}

		setPendingMarkerData(null);
		unlockPopup();
	};



	// ✅ FIX 2: Update InitMap to pass groupName when restoring markers
	async function InitMap() {
		const map = mapRef.current;
		if (!map) return;

		map.events.addOnce('ready', () => {
			if (
				enableMarker &&
				Array.isArray(selectedAddLanLot) &&
				selectedAddLanLot?.length === 2
			) {
				const [latitude, longitude] = selectedAddLanLot;
				map.setCamera({
					center: [longitude, latitude],
					zoom: 18
				});
			}

			if (props.defaultaddress && latitude && longitude) {
				const searchedLocationId = "searched-location-pin";
				addMarker(latitude, longitude, "Searched Location", searchedLocationId, true);
			}

			if (map && map.events && map.events.add && !map._listenersAdded) {
				map._listenersAdded = true;

				// ✅ Restore existing markers with their group assignments
				areasMarked.forEach(area => {
					const { Latitude, Longitude, Title } = area.Coordinates;
					const vehicleSize = area?.VehicleSpotSize || "";
					const existingPslName = area?.pslName || "";
					const existingGroupName = area?.groupName || null; // ✅ Get existing group

					addMarker(
						Latitude,
						Longitude,
						Title,
						area.id,
						true,
						vehicleSize,
						existingPslName,
						existingGroupName  // ✅ Pass existing group
					);
				});

				map.events.add('click', function (e) {
					const clickedLatitude = e.position[1];
					const clickedLongitude = e.position[0];
					const newId = Date.now();
					if (selectedOptionRef?.current?.length !== 0) {
						addMarker(clickedLatitude, clickedLongitude, selectedOptionRef?.current, newId);
					}
				});
			}
		});
	}
	// Hide SpotSizePopup if PSL marker is removed
	useEffect(() => {
		const hasPSL = areasMarked.some(
			(area) => area.Name === "PSL - Parking Space Location"
		);
		if (hasPSL && hasPSL.groupName) {
			setSelectedGroup(area.groupName);
		}
		if (!hasPSL) {
			setShowSpotSizePopup(false);
			setSpotPopupPosition(null);
			setPendingMarkerData(null);
			unlockPopup && unlockPopup();
		}
	}, [areasMarked]);

	useEffect(() => {
		if (mapRef.current) {
			InitMap();
		}
	}, [enableMarker, scheduleavailability]);

	useEffect(() => {
		if (props.areasMarked) {
			setOnlyPark(props.parkinglotObj?.isParkingSpaceSelected);
			setRoboTaxis(props.parkinglotObj?.isRoboTaxiSelected);
			setTimeValues(props?.parkinglotObj?.scheduleavailability?.timeSlot);
			setWeekoption(props?.parkinglotObj?.scheduleavailability?.weekOption);
			setSelectedValue(props?.parkinglotObj?.scheduleavailability?.weekOption);

			// ✅ RESTORE GROUPS
			const existingGroupNames = new Set();
			props.areasMarked.forEach(marker => {
				if (marker.Name === "PSL - Parking Space Location" && marker.groupName && marker.groupName !== "Default") {
					existingGroupNames.add(marker.groupName);
				}
			});

			if (existingGroupNames.size > 0) {
				const restoredGroups = Array.from(existingGroupNames).map((name, index) => ({
					id: Date.now() + index,
					name: name,
					color: groupColors[(index + 1) % groupColors.length],
					editing: false
				}));

				setGroups(prev => {
					const defaultGroup = prev.find(g => g.name === "Default");
					return [defaultGroup, ...restoredGroups];
				});
			}

			// Set selected group from first PSL marker
			const firstPSL = props.areasMarked.find(m => m.Name === "PSL - Parking Space Location");
			if (firstPSL?.groupName) {
				setSelectedGroup(firstPSL.groupName);
			}

			// ✅ FIX: Initialize PSL counter based on existing markers
			const pslMarkers = props.areasMarked.filter(m => m.Name === "PSL - Parking Space Location" && m.pslName);
			if (pslMarkers.length > 0) {
				const maxPslNumber = Math.max(...pslMarkers.map(m => {
					const match = m.pslName.match(/^PSL(\d+)$/);
					return match ? parseInt(match[1]) : 0;
				}));
				pslCounterRef.current = maxPslNumber;
			}

			setConditions({
				"1 of 5 - Locate your Property": false,
				"2 of 5 - Mark Parking Spaces & Other Areas": true,
				"3 of 5 - Schedule Availability": false,
				"4 of 5 - Enter Bank Details": false,
				"5 of 5 - Review and Confirm": false
			});

			// ... rest of the existing code ...
			const newCounts = { ...areas };
			const newPickUPsDropoffCounts = { ...PickUPSDropoffs }
			const PickUPSDropdoffs = areasMarked.filter((name) => (name.Name === "PUE - Pick Up Entrance") || (name.Name === "DOE - Drop Off Entrance") || (name.Name === "PUL - Pick Up Location") || (name.Name === "DOL - Drop Off Location") || (name.Name === "PUX - Pick Up Exit") || (name.Name === "DOX - Drop Off Exit"))

			areasMarked.forEach(marker => {
				const title = marker.Name;
				setSelectedOption(title);
				if (newCounts.hasOwnProperty(title)) {
					newCounts[title] = (newCounts[title] || 0) + 1;
				}
			});

			PickUPSDropdoffs.forEach(marker => {
				const title = marker.Name;
				setSelectedOption(title);
				if (newPickUPsDropoffCounts.hasOwnProperty(title)) {
					newPickUPsDropoffCounts[title] = (newPickUPsDropoffCounts[title] || 0) + 1;
				}
			});

			setAreas(newCounts);
			setPickUPSDropoffs(newPickUPsDropoffCounts)
			setSearchdisabled(true);
			setCurrentStep(2);
			setConfirmAddress(true);
			setOptionerror(false);
			setEnablemarker(true)
			setFrameOpen(false);
			setExpandedMark(true);
			setExpandedMarkSpace(true);
			setSelectedOption([]);

			const bankData = props?.parkinglotObj?.bankDetails;
			setbankaccountdetails(bankData);

			if (props.editOption === 'parkingschedule') {
				setscheduleavailability(true);
				setExpanded(true)
			}
			else if (props.editOption === 'bankdetails') {
				setscheduleavailability(true);
				setBankdetails(true);
				setExpanded(true)
			}
		}
	}, [props.areasMarked]);

	useEffect(() => {
		// Update all markers' text when selectedOption changes
		markers.forEach(marker => {
			if (marker._textElement) {
				marker._textElement.textContent = selectedOption?.substring(0, 3);
			}
		});
	}, [selectedOption]);
	const searchLocation = (locationName) => {
		var data = []
		data.location = locationName
		axios.get(`https://atlas.microsoft.com/search/address/json?&subscription-key=EN5vcaicwC78zKi3M3980VVB1m7DuuN0vKaDMtYdjBg7daKhx3OTJQQJ99AHAC8vTIngVrqvAAAgAZMPLtXG&api-version=1.0&language=en-US&query=${locationName}`)
			.then((response) => {
				const results = response.data.results;
				if (results && results.length > 0) {
					const firstResult = results[0];

					const { position } = firstResult;
					setLatitude(position.lat);
					setSelectedAddLanLot([position.lat, position.lon]);
					setLongitude(position.lon);
					setCurrentproperty(firstResult?.address);
					setCurrentpropertyaddress(firstResult?.address?.freeformAddress)
					setStreetname(firstResult?.address?.streetName);
					setSelectedCountry(firstResult?.address?.country);
				}
			})
			.catch((error) => {
				console.error('Error fetching location data:', error);
			});
	};

	useEffect(() => {
		if (props?.defaultaddress?.trim() !== '') {
			searchLocation(props.defaultaddress);
		}
	}, [props.defaultaddress]);

	const getDataFromAPI = (event, value) => {
		if (value) {
			const locationName = value.trim();
			if (locationName !== '') {
				setAddressvalue(locationName);

				setTimeout(async () => {
					searchLocation(locationName, map);

					try {
						const response = await axios.get(
							`https://atlas.microsoft.com/search/fuzzy/json?&subscription-key=EN5vcaicwC78zKi3M3980VVB1m7DuuN0vKaDMtYdjBg7daKhx3OTJQQJ99AHAC8vTIngVrqvAAAgAZMPLtXG&api-version=1.0&query=${encodeURIComponent(locationName)}`
						);
						//CHECK THIS LINE
						const result = response.data?.results?.[0];
						const address = result?.address;
						const position = result?.position;
						setSelectedAddLanLot([position?.lat, position?.lon]);

						if (address) {
							const country = address.country;
							setSelectedCountry(country);
						}
					} catch (error) {
						console.error('Failed to extract location info:', error);
					}
				}, 1000);
			}
		} else {
			searchLocation(props.defaultaddress, map);
			setAddressvalue('');
		}
	};


	useEffect(() => {
		if (searchValue?.trim() !== '') {
			// Fetch suggestions from API
			axios.get(`https://atlas.microsoft.com/search/fuzzy/json?&subscription-key=EN5vcaicwC78zKi3M3980VVB1m7DuuN0vKaDMtYdjBg7daKhx3OTJQQJ99AHAC8vTIngVrqvAAAgAZMPLtXG&api-version=1.0&language=en-US&query=${searchValue}&extendedPostalCodesFor=PAD,Addr,POI,Str,Xstr&limit=10&countrySet=US`)
				.then(response => {
					const results = response.data.results;
					if (results && results.length > 0) {
						const suggestedLocations = results
							.filter(result => result.address.countryCode === 'US' && result.address.streetNumber)
							.map(result => ({
								label: result.address.freeformAddress,
								lat: result.position.lat,
								lon: result.position.lon
							}));
						const selecetedAddress = results?.filter(result => result.address.countryCode === 'US').map(result => result.address);
						setSuggestions(suggestedLocations);
						setSelecetedAddress(selecetedAddress);
					}
				})
				.catch(error => {
					console.error('Error fetching location suggestions:', error);
				});
		} else {
			setAddressvalue('');
			setSuggestions([]);

		}
	}, [searchValue]);

	const handleSearchChange = (value) => {
		const invalidCharacters = /[^a-zA-Z0-9\s,]/;
		if (invalidCharacters.test(value)) {
			setSearchError(true);
		} else {
			setSearchError(false);
		}
		setSearchValue(value);

		if (value.length > 5 && duplicateAddressError && !issearchdisabled) {
			toast.error("Property address already exists. Please enter a new address.", {
				toastId: "duplicateAddressError",
				position: "top-right",
				autoClose: 3000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
			});
			return;
		}

		if (props.defaultaddress !== addressvalue) {
			if (addressvalue === null || addressvalue === "") {

			} else {

				setareasmarked([]);
				setPropertyNickName("")
				setAreas({
					"PSL - Parking Space Location": 0,
					"PKE - Parking Entrance": 0,
					"PKX - Parking Exit": 0,
				});
				setPickUPSDropoffs({
					"PUE - Pick Up Entrance": 0,
					"DOE - Drop Off Entrance": 0,
					"PUL - Pick Up Location": 0,
					"DOL - Drop Off Location": 0,
					"PUX - Pick Up Exit": 0,
					"DOX - Drop Off Exit": 0
				});
			}
		}
	};

	useEffect(() => {
		setAccountinfo({
			BankName: bankaccountdetails ? bankaccountdetails.bankName : "",
			AccountHolderName: bankaccountdetails ? bankaccountdetails.accountHolderName : "",
			AccountType: bankaccountdetails ? bankaccountdetails.accountType : "",
			AccountNumber: bankaccountdetails ? bankaccountdetails.accountNumber : "",
			RoutingNumber: bankaccountdetails ? bankaccountdetails.routingNumber : "",
			SWIFT_BIC_Code: bankaccountdetails ? bankaccountdetails.swifT_BIC_Code : "",
		});
	}, [bankaccountdetails]);

	useEffect(() => {
		if (onlyPark) {
			const updateAreas = areasMarked.filter((name) => (name.Name === "PSL - Parking Space Location") || (name.Name === "PKE - Parking Entrance") || (name.Name === "PKX - Parking Exit"))
			setareasmarked(updateAreas)
		}
	}, [props.areasMarked])

	useEffect(() => {
		if (registrationId) {
			const emailId = {
				"EmailId": stateLogedInUser
			}
			const requestOptions = {
				method: 'POST',
				headers: { "x-functions-key": `${hostHeader}` },
				body: emailId
			};
			axios.get(`${hostPath}/api/UpdateBankDetails/` + registrationId, { headers: requestOptions.headers })
				.then(response => {
					if (response.data) {
						const bankdetails = response.data;
						setbankaccountdetails(bankdetails);
					}
				})
				.catch(error => {
					console.error('Error:', error);
				});
		}
	}, [])



	useEffect(() => {
		if (!roboTaxiPopup) return;
		if (!Array.isArray(areasMarked) || areasMarked.length === 0) return;

		const pslLabels = areasMarked
			.filter(a => a.Name === "PSL - Parking Space Location")
			.map(a => a.pslName);

		const validSaved = savedRoboTaxiPSLs.filter(psl =>
			pslLabels.includes(psl)
		);

		setDraftRoboTaxiPSLs(validSaved);
		setSelectedPSLCheckboxes(savedRoboTaxiPSLs)
	}, [roboTaxiPopup, savedRoboTaxiPSLs, areasMarked]);


	const newEventTriggered = (newEvent) => {
		SetEventTriggered(newEvent)
	}
	const handleSave = async (e, isConfirm = false) => {
		e.preventDefault();
		if (isSaveDisabled) return;

		const searchLocation =
			addressvalue?.length > 0
				? addressvalue
				: props.defaultaddress?.trim();

		/* ============================================================
		   1️⃣ COORDINATE DETAILS
		============================================================ */
		const CoardinateDetails = (areasMarked || []).map(item => ({
			Latitude: item.Coordinates.Latitude.toString(),
			Longitude: item.Coordinates.Longitude.toString(),
			Title: item.Coordinates.Title,
			ID: item.id.toString(),
			VechileSpotSize: item?.VehicleSpotSize || "",
			pslName: item.pslName || "",
			groupName: item.groupName || "Default",
			ScheduleAvailability: []
		}));
		const groupSchedules = (() => {
			const map = {};

			events
				.filter(e => e.isMaster === true)
				.forEach(evt => {
					const groupName = evt.groupName || "Default";
					if (!map[groupName]) map[groupName] = [];

					const groupPSLs = (areasMarked || [])
						.filter(a => (a.groupName || "Default") === groupName)
						.map((a, i) => ({
							id: Number(a.id),
							pslName: a.pslName || `PSL${i + 1}`
						}));

					map[groupName].push({
						// id: evt.recurrenceId || evt.id,
						id: evt.recurrenceId || evt.id,
						title: evt.title,
						allDay: evt.allDay || false,

						// 🔹 RECURRENCE FIELDS (IMPORTANT)
						recurrence: evt.recurrence || null,
						customRecurrenceType: evt.customRecurrenceType || null,
						customRecurrenceCount: evt.customRecurrenceCount || 1,
						selectedDays: evt.selectedDays || [],

						// 🔹 DATE FIELDS
						start: evt.start,
						end: evt.end,
						endType: evt.endType,
						endDateOn: evt.endDateOn,
						endAfter: evt.endAfter || null,

						// 🔹 META
						recurrenceSummary: evt.recurrenceSummary || "",
						isHoliday: evt.isHoliday || false,
						recurrenceId: evt.recurrenceId || evt.id,

						assignedPSLs: groupPSLs,

						isMaster: true,
						isActive: false
					});
				});

			return Object.keys(map).map(groupName => ({
				groupName,
				schedules: map[groupName]
			}));
		})();


		/* ============================================================
		   3️⃣ BANK DETAILS
		============================================================ */
		const BankDetails = {
			...accountinfo,
			EntityRegistrationID: entity
		};

		const prev = lastSavedStateRef.current;

		const isAddressChanged =
			prev?.addressvalue !== searchLocation;

		const isScheduleChanged =
			JSON.stringify(prev?.events || []) !== JSON.stringify(events || []);

		const isPSLChanged =
			JSON.stringify(prev?.areasMarked || []) !== JSON.stringify(areasMarked || []);

		const hasPickDropOff = areas =>
			areas?.some(a =>
				[
					"PUE - Pick Up Entrance", "DOE - Drop Off Entrance",
					"PUL - Pick Up Location", "DOL - Drop Off Location",
					"PUX - Pick Up Exit", "DOX - Drop Off Exit"
				].includes(a.Name)
			);

		const hasParkingSpaces = areas =>
			areas?.some(a =>
				["PSL - Parking Space Location", "PKE - Parking Entrance", "PKX - Parking Exit"]
					.includes(a.Name)
			);

		try {
			setLoader(true);

			const savedLot = props?.parkinglotObj;

			const isFirstSave = !savedLot && !parkinglotId;

			/* ============================================================
			   UPDATE (SAVE AGAIN / CONFIRM)
			============================================================ */
			if (savedLot?.parkingLotId || savedLot?.parking_Lot_ID) {
				const updatePayload = {
					EmailId: stateLogedInUser,
					EntityRegistrationID: entity,
					ParkingLotAddress: searchLocation,

					Parking_Lot_ID: savedLot.parkingLotId || savedLot.parking_Lot_ID,
					id: savedLot.id,
					CreatedDate: savedLot.createdDate,

					Status: isConfirm ? "Active" : "Draft",
					StreetName: streetname,
					EmpId: props.empId || 0,
					CreatedBy: createdBy,

					CoardinateDetails,
					groupSchedules,
					NickName: PropertyNickName,
					MaxRoboTaxiSpots: roboTaxiLimit,
					isParkingSpaceSelected: onlyPark,
					isRoboTaxiSelected: RoboTaxis,
					roboTaxiSpotsName: savedRoboTaxiPSLs,
					BankDetails: BankDetails?.AccountNumber ? BankDetails : undefined
				};

				if (props.parkinglotObj.coardinateDetails.length > 0) {
					const PickDropoffs = props.parkinglotObj.coardinateDetails?.filter((name) => (name.Name === "PUE - Pick Up Entrance") || (name.Name === "DOE - Drop Off Entrance") || (name.Name === "PUL - Pick Up Location") ||
						(name.Name === "DOL - Drop Off Location") || (name.Name === "PUX - Pick Up Exit") || (name.Name === "DOX - Drop Off Exit"))
					const ParkingSpaces = props.parkinglotObj.coardinateDetails?.filter((name) => (name.Name === "PSL - Parking Space Location") || (name.Name === "PKE - Parking Entrance") || (name.Name === "PKX - Parking Exit"))
					if (showPickUPSDropoffs && PickDropoffs && !scheduleavailability) {
						toast.dismiss();
						toast.success("PicksUP/DropOffs Updated Successfully!");
					} else if (!showPickUPSDropoffs && ParkingSpaces && !scheduleavailability) {
						toast.dismiss();
						toast.success("Parking Spaces Updated Successfully!");
					}
					else if (isScheduleChanged || scheduleavailability) {
						toast.dismiss();
						toast.success("Schedule updated successfully!");
					}
				}


				await axios.post(
					`${hostPath}/api/UpdateParkingLotDetails`,
					updatePayload,
					{ headers: { "x-functions-key": hostHeader } }
				);
				lastSavedStateRef.current = {
					addressvalue,
					areasMarked: [...areasMarked],
					accountinfo: { ...accountinfo },
					events: { ...events },
					PropertyNickName
				};

			}
			else {
				const basePayload = {
					EmailId: stateLogedInUser,
					Status: "Draft",
					StreetName: streetname,
					EntityRegistrationID: entity,
					EmpRegistrationID: empentity,
					ParkingLotAddress: searchLocation,
					EmpId: props.empId || 0,
					CreatedBy: createdBy,

					CoardinateDetails,
					groupSchedules,

					NickName: PropertyNickName,
					MaxRoboTaxiSpots: roboTaxiLimit,
					isParkingSpaceSelected: onlyPark,
					isRoboTaxiSelected: RoboTaxis,
					roboTaxiSpotsName: savedRoboTaxiPSLs,
					BankDetails: BankDetails?.AccountNumber ? BankDetails : undefined
				};

				/* --------------------------------------------
				   🔹 IF parkingLotId exists → UPDATE
				-------------------------------------------- */
				if (parkinglotId?.parkingLotId || parkinglotId?.parking_Lot_ID) {
					const updatePayload = {
						...basePayload,
						Parking_Lot_ID:
							parkinglotId.parkingLotId || parkinglotId.parking_Lot_ID,
						id: savedLot?.id,
						CreatedDate: savedLot?.createdDate

					};

					await axios.post(
						`${hostPath}/api/UpdateParkingLotDetails`,
						updatePayload,
						{ headers: { "x-functions-key": hostHeader } }
					);

					toast.dismiss();
				}

				/* --------------------------------------------
				   🔹 ELSE → CREATE (FIRST TIME)
				-------------------------------------------- */
				else {
					const res = await axios.post(
						`${hostPath}/api/ParkingLotBooking`,
						basePayload,
						{ headers: { "x-functions-key": hostHeader } }
					);

					if (res?.data) {
						setParkinglotId(res.data);
					}
				}
				toast.dismiss();
				if (parkinglotId?.parkingLotId || parkinglotId?.parking_Lot_ID) {
					toast.dismiss();

					if (isConfirm) {
						toast.success("Parking lot confirmed successfully!");
					}
					else if (isScheduleChanged || scheduleavailability) {
						toast.dismiss();
						toast.success("Schedule updated successfully!");
					}
					else if (isPSLChanged || isAddressSelected) {
						if (showParkOnly) {
							toast.success("Parking spaces updated successfully!");
						}
						else if (showPickUPSDropoffs && !scheduleavailability) {
							toast.dismiss();
							toast.success("Pick-up / Drop-off updated successfully!");

						}

					}
					else if (isAddressChanged || !isAddressSelected) {
						toast.dismiss();
						toast.success("Parking lot address updated successfully!");
					}
				}
				else {

					if (isConfirm) {
						toast.success("Parking lot confirmed successfully!");
					}
					else if (isScheduleChanged || scheduleavailability) {
						toast.dismiss();
						toast.success(
							isFirstSave
								? "Schedule saved successfully!"
								: "Schedule updated successfully!"
						);
					}
					else if (isPSLChanged || isAddressSelected) {
						if (showParkOnly) {
							toast.dismiss();
							toast.success(isFirstSave ? "Parking spaces saved successfully!" : "Parking spaces updated successfully!");
						}
						else if (showPickUPSDropoffs && !scheduleavailability) {
							toast.dismiss();
							toast.success(isFirstSave ? "Pick-up / Drop-off saved successfully!" : "Pick-up / Drop-off updated successfully!");
						}

					}
					else if (isAddressChanged) {
						toast.success(
							isFirstSave
								? "Parking lot address saved successfully!"
								: "Parking lot address updated successfully!"
						);
					}
					else if (isFirstSave) {
						toast.dismiss();
						toast.success("Parking lot saved successfully!");
					}
				}

				/* ============================================================
				   SAVE SNAPSHOT
				============================================================ */
				lastSavedStateRef.current = {
					addressvalue: searchLocation,
					areasMarked: [...areasMarked],
					accountinfo: { ...accountinfo },
					events: [...events],
					PropertyNickName
				};

				setAutosave(true);
			}
		} catch (err) {
			console.error("handleSave error:", err);
		} finally {
			setLoader(false);
			setRoboTaxiPopup(false);
			setRoboTaxiAlert(false);
			mapVisibleChangesAlert(false);
		}
	};


	useEffect(() => {
		if (isScheduleDeleted) {
			handleSave();
			setIsScheduleDeleted(false);
		}
	}, [isScheduleDeleted]);

	const handleAccord = () => {
		setExpanded(!expanded);
	}
	const handleMarkerAccord = () => {
		setExpandedMark(!expandedMark);
	}
	const handleMarkerAccordSpace = () => {
		setExpandedMarkSpace(!expandedMarkSpace);
	}

	const toggleCondition = (key) => {
		setConditions((prevConditions) => ({
			...prevConditions,
			[key]: !prevConditions[key],
		}));
	};
	const handleSearchclick = () => {
		setSelectedOption([]);
		if (!isAddressSelected) {
			setDashboard(true);
			setFrame1Open(true);
			setAlertpopup(false);
		}
		else {
			setAlertpopup(true);
			setFrame1Open(true);
		}
	}
	const handleBackclick = () => {
		unlockPopup();
		setPendingMarkerData(null);
		setShowSpotSizePopup(false);
		setSpotPopupPosition(null);

		if (!isAddressSelected) {
			setDashboard(true);
			setFrame1Open(true);
			setAlertpopup(false);
			setCurrentStep(1); // REQUIRED

		} else if (showPickUPSDropoffs) {
			setConditions({
				"1 of 6 - Locate your Property": false,
				"2 of 6 - Mark Parking Spaces": true,
				"3 of 6 - Pick ups and  Drop offs": false,
				"4 of 6 - Schedule Availability": false,
				"5 of 6 - Enter Bank Details": false,
				"6 of 6 - Review and Confirm": false,
			});
			setshowParkOnly(true);
			setShowPickUPSDropoffs(false);
			setCurrentStep(2);

		} else {
			setshowParkOnly(true);
			setAlertpopup(true);
			setFrame1Open(true);
			setCurrentStep(1); // THIS WAS MISSING
		}
	};

	const navigateToDashboard = (isDashboard) => {
		navigate('/dashboard', { state: { isDashboard } });
	};
	const handleAddressreset = () => {
		resetStates(1);
	}

	const handleChangeAccordian = () => {
		setExpanded(!expanded);
	};
	const handleNavigate = (newDate) => {
		if (typeof newDate === 'string') {
			const currentDate = new Date(selectedDate);
			switch (newDate) {
				case 'PREV':
					currentDate.setMonth(currentDate.getMonth() - 1);
					setSelectedDate(new Date(currentDate));
					break;
				case 'NEXT':
					currentDate.setMonth(currentDate.getMonth() + 1);
					setSelectedDate(new Date(currentDate));
					break;
				case 'TODAY':
					setSelectedDate(new Date());
					break;
				default:
					break;
			}
		} else if (newDate instanceof Date) {
			setSelectedDate(newDate);
		}
	};
	const handleAddEvent = () => {
		mapVisibleChangesAlert(true);
	};

	const handleReset = () => {
		mapVisibleChangesAlert(false);
	};
	const areArraysDifferent = (arr1, arr2) => {
		if (arr1.length !== arr2.length) return true;

		const ids1 = arr1.map(item => item.id).sort();
		const ids2 = arr2.map(item => item.id).sort();

		return JSON.stringify(ids1) !== JSON.stringify(ids2);
	};
	function areEventsDifferent(beforeEvent, afterEvent) {
		if (beforeEvent.length !== afterEvent.length) {
			return true;
		}

		const formatDate = (date) => new Date(date).toISOString();

		const sortedBefore = [...beforeEvent].sort((a, b) => formatDate(a.start).localeCompare(formatDate(b.start)));
		const sortedAfter = [...afterEvent].sort((a, b) => formatDate(a.start).localeCompare(formatDate(b.start)));

		for (let i = 0; i < sortedBefore.length; i++) {
			if (
				formatDate(sortedBefore[i].start) !== formatDate(sortedAfter[i].start) ||
				formatDate(sortedBefore[i].end) !== formatDate(sortedAfter[i].end)
			) {
				return true;
			}
		}

		return false;
	}

	const isParkingLocation = (text) =>
		["PSL - Parking Space Location", "PKE - Parking Entrance", "PKX - Parking Exit"].includes(text);
	const isPickUpOrDropOff = (text) =>
		[
			"PUE - Pick Up Entrance",
			"DOE - Drop Off Entrance",
			"PUL - Pick Up Location",
			"DOL - Drop Off Location",
			"PUX - Pick Up Exit",
			"DOX - Drop Off Exit"
		].includes(text);

	const canDeleteInCurrentStep = (markerName) => {


		if (currentStep === 1) {
			return false;
		}

		if (currentStep === 2) {
			return isParkingLocation(markerName);
		}
		if (currentStep === 3) {
			return isPickUpOrDropOff(markerName);
		}

		return false;
	};



	useEffect(() => {
		const toastTop = expandedMark ? '140px' : '30px';
		const checkingAreasLocation = areArraysDifferent(props.areasMarked ?? [], areasMarked);
		const comparingEvent = areEventsDifferent(props?.parkinglotObj?.scheduleavailability ?? "", events);
		if (addressvalue.length > 0 || PropertyNickName.length !== (props.parkinglotObj?.nickName ?? "").length || checkingAreasLocation === true || comparingEvent === true || props.isEdit && props.checkReviewTab) {
			handleAddEvent()
		}
		else {
			handleReset()
		}
		if (areasMarked.length === 0 && optionerror) {
			if (!toast.isActive('error-toast')) {
				toast.error('Mark Parking Spaces: Parking Spot Location Markers', {
					autoClose: 3000,
					hideProgressBar: false,
					closeOnClick: false,
					draggable: false,
					className: 'custom-toast',
					style: {
						top: toastTop,
						left: '-3%',
						position: 'absolute',
						zIndex: 10,
					},
					toastId: 'error-toast',
					onClose: () => setOptionerror(false),
				});
			} else {
				toast.update('error-toast', {
					className: 'custom-toast',
					style: {
						top: toastTop,
						left: '-3%',
						position: 'absolute',
					},
				});
			}
		} else if (!optionerror) {

		}
		const count = areasMarked.filter(area => area.Name === 'PSL - Parking Space Location').length;
		setPslCount(count);
		if (showPickUPSDropoffs || scheduleavailability) {
			if (!props.parkinglotObj && RoboTaxis && roboTaxiLimit === 0) {
				setPslPage(true);
				setRoboTaxiPopup(true)
				setRoboTaxiAlert(true)
			}
			else if (!props.parkinglotObj && RoboTaxis && roboTaxiLimit > pslCount) {
				setPslPage(true);
				setRoboTaxiPopup(true)
				setRoboTaxiAlert(true)
			}
			//check in this line
			else if (props.parkinglotObj && RoboTaxis && pslCount < roboTaxiLimit && roboTaxiLimit > 0) {
				setPslPage(true);
				setRoboTaxiPopup(true)
				setRoboTaxiAlert(true);
			}
			//check in this line
			else if (props.parkinglotObj && RoboTaxis && roboTaxiLimit === 0) {
				setPslPage(true);
				setRoboTaxiPopup(true)
				setRoboTaxiAlert(true);
			}
		}
	}, [areasMarked, optionerror, isPopupLocked, expandedMark, PropertyNickName, addressvalue, props.parkinglotObj?.nickName, events, showPickUPSDropoffs, scheduleavailability]);
	const clearRoboTaxiSelection = () => {
		setSavedRoboTaxiPSLs([]);
		setDraftRoboTaxiPSLs([]);
		setRoboTaxiLimit(0);
		setRoboTaxiAlert(false);
		setIsLimitButton(false);
	};

	const handleSetPopup = () => {
		setDraftRoboTaxiPSLs([...savedRoboTaxiPSLs]);
		setRoboTaxiPopup(true);
		setRoboTaxiAlert(true);
		setIsLimitButton(true);
	}
	const handleSaveLimit = (e) => {
		if (RoboTaxis) {
			if (!draftRoboTaxiPSLs || draftRoboTaxiPSLs.length === 0) {
				setRoboTaxiCountError(
					"At least 1 spot should be assigned for RoboTaxis."
				);
				setRoboTaxiPopup(true);
				return;
			}

			// ✅ THIS LINE FIXES EVERYTHING
			setSavedRoboTaxiPSLs([...draftRoboTaxiPSLs]);

			setRoboTaxiLimit(draftRoboTaxiPSLs.length);
			setRoboTaxiCountError("");
			setRoboTaxis(true);
		}

		setRoboTaxiPopup(false);
		//   handleSave(e);
	};

	return (
		<>
			{loader && (
				<div style={{
					position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 99999
				}}>
					<FadeLoader color="#36d7b7" loading={loader} />
				</div>
			)}

			{/* <div className="map"> */}
			<div className={scheduleavailability ? "d-flex" : "flex-container"}>
				<div style={{ display: 'flex', flexDirection: 'column' }}>
					<AccordionSummary
						expanded={expanded}
						onChange={handleChangeAccordian}
						disableDivider
						sx={{ maxWidth: 1000 }}
						style={{
							zIndex: 1000,
							position: 'relative',
							alignItems: 'center',
							padding: '50px',
							maxWidth: '350px',
						}}
						className="vector-parent"
					>
						<Accordion expanded={expanded} onChange={handleAccord}>
							<AccordionSummary
								expandIcon={
									expanded ? (
										<RemoveIcon data-testid="RemoveIcon" />
									) : (
										<AddIcon data-testid="AddIcon" />
									)
								}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								Property Registration Steps
							</AccordionSummary>
							{(onlyPark ? stepParkOnly : steps).map((step, index) => (
								<AccordionDetails
									key={step}
									className={`AccordName ${onlyPark ? (conditions1[step] ? 'selected' : '') : conditions[step] ? 'selected' : ''}`}
								>
									{step}
								</AccordionDetails>
							))}
						</Accordion>
					</AccordionSummary>
					{/* Property Nickname Input Field */}


					{/* Date picker under AccordionSummary when scheduleavailability is true */}
					{scheduleavailability && !bankdetails && (
						<div style={{ marginBottom: '20px', marginTop: '10px', marginLeft: '40px' }}>
							<LocalizationProvider dateAdapter={AdapterDateFns}>
								<StaticDatePicker
									displayStaticWrapperAs="desktop"
									openTo="day"
									value={selectedDate}
									onChange={handleDatePickerChange}
									sx={{
										'& .MuiPickerStaticWrapper-root': {
											width: '100%',
										},
										'& .MuiPickersDay-root': {
											fontSize: '14px',
										},
										'& .MuiPickersDay-dayWithMargin': {
											margin: '1px',
										},
										'& .MuiCalendarPicker-root': {
											fontSize: '12px',
										},
										'& .MuiPickersCalendarHeader-label': {
											fontSize: '16px',
										},
										'& .MuiPickersArrowSwitcher-root button': {
											fontSize: '1.2rem',
										},
									}}
								/>
							</LocalizationProvider>
						</div>
					)}
				</div>
				<div style={accordionStyles}>
					{!scheduleavailability ? (
						<div>
							<div className="map-child" id="myMap" data-testid="myMap"></div>
							<div className="material-symbolsquestion-mark-wrapper" style={{ left: "400px" }} onClick={openFrame}>
								<img className="material-symbolsquestion-mark-icon" alt="" src="question-mark.png" />
							</div>
							{showPickUPSDropoffs ?
								<div className="next-wrapper" onClick={nextBtn}>
									<b className="next">Next</b>
								</div> :
								<div className="next-wrapper" onClick={openFrame1}>
									<b className="next">Next</b>
								</div>
							}
							<div className="back-wrapper" onClick={handleBackclick}>
								<b className="next">Back</b>
							</div>
							<div
								className="autosave1-wrapper"
								onClick={(e) => handleSave(e)}
								style={{
									pointerEvents: isSaveDisabled ? 'none' : 'auto',
									opacity: isSaveDisabled ? 0.5 : 1,
								}}
							>
								<b className="next">Save</b>
							</div>
							<div className="component-1" style={{ display: 'flex' }}>
								<>
									{!issearchdisabled ? (
										<div className='search-property'>
											<div className="enter-your-address">
												<Autocomplete
													style={{ width: 300, backgroundColor: "white", marginLeft: "-0%", borderRadius: "10px", flexShrink: "1" }}
													freeSolo
													autoComplete
													autoHighlight
													options={suggestions}
													getOptionLabel={(option) => option.label}
													filterOptions={(x) => x}
													onChange={(event, value) => {
														if (value) {
															getDataFromAPI(event, value.label);
														}
													}
													}
													onInputChange={(event, value) => {
														setAddressvalue(value);
														setSearchError(false);
													}}
													disabled={issearchdisabled || loader}
													value={suggestions.find((s) => s.label === addressvalue) || { label: addressvalue || '' }}
													renderInput={(params) => (
														<TextField
															{...params}
															onChange={(e) => { handleSearchChange(e.target.value); }}
															variant="filled"
															label="Search Box"
															disabled={issearchdisabled || loader}
															value={addressvalue}
														/>
													)}
												/>
												{searchError && (
													<div style={{ color: 'red', marginTop: '8px' }}>
														Enter alphabetic characters only
													</div>
												)}
											</div>
											<div style={{ position: "relative", display: "inline-block" }}>
												<input
													type="text"
													name="nickname"
													id="nickname"
													placeholder="Property Nickname"
													value={PropertyNickName}
													onChange={handleInputChange}
													style={{
														marginRight: "10px",
														padding: "10px",
														width: "300px",
														borderRadius: "5px",
														border: "1px solid #ccc",
													}}
												/>

												<span
													style={{
														color: "red",
														position: "absolute",
														right: "-15px",
														top: "50%",
														transform: "translateY(-50%)",
														fontSize: "45px",
													}}
												>
													*
												</span>

											</div></div>) : <div className='set-limit'>
										{showParkOnly && RoboTaxis && savedRoboTaxiPSLs.length > 0 &&
											<button className='set-limit-button' onClick={handleSetPopup}>Set Limit</button>
										}
										<GrFormSearch
											data-testid="GrFormSearch"
											onClick={handleSearchclick} style={{ backgroundColor: 'white', height: '50px', width: '50px', borderRadius: "10px", marginTop: "13px", cursor: "pointer" }} /></div>
									}


									{isAddressSelected && issearchdisabled && (
										<div
											className="d-flex flex-row"
											style={{ gap: "12px", width: "100%", alignItems: "flex-start" }}
										>
											{/* ✅ Groups Accordion */}
											{showParkOnly &&
												<Accordion
													expanded={expandedGroups}
													onChange={handleGroupsAccord}
													disableGutters
													square={false}
													sx={{
														flex: 1,
														backgroundColor: "white",
														borderRadius: "12px !important",
														boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
														"&:before": { display: "none" },
													}}
												>
													<AccordionSummary
														expandIcon={expandedGroups ? <RemoveIcon /> : <AddIcon />}
														sx={{
															fontWeight: "bold",
															fontSize: "14px",
															minHeight: "48px",
															"& .MuiAccordionSummary-content": {
																margin: 0,
																display: "flex",
																alignItems: "center",
															},
														}}
													>
														Groups ({groups.length}/5){" "}
														<InfoIcon sx={{ fontSize: "16px", marginLeft: "6px" }} />
													</AccordionSummary>

													<AccordionDetails
														sx={{
															padding: "8px 16px",
															backgroundColor: "white",
															borderRadius: "0 0 12px 12px",
														}}
													>
														{groups.map((g) => (
															<div
																key={g.id}
																className="group-row"
																style={{
																	display: "flex",
																	alignItems: "center",
																	justifyContent: "space-between",
																	padding: "6px",
																	borderRadius: "6px",
																	marginBottom: "4px",
																	backgroundColor: selectedGroup === g.name ? "#e6f0ff" : "transparent",
																	cursor: "pointer",
																}}
																onClick={() => setSelectedGroup(g.name)}
															>
																<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
																	<span
																		style={{
																			width: "12px",
																			height: "12px",
																			borderRadius: "50%",
																			backgroundColor: g.color,
																			display: "inline-block",
																		}}
																	/>
																	{g.editing ? (
																		<input
																			type="text"
																			autoFocus
																			defaultValue={g.name}
																			onBlur={(e) => handleSaveGroupName(g.id, e.target.value)}
																			onKeyDown={(e) => {
																				if (e.key === "Enter") handleSaveGroupName(g.id, e.target.value);
																			}}
																			style={{
																				border: "1px solid #ccc",
																				borderRadius: "4px",
																				padding: "2px 6px",
																				fontSize: "14px",
																			}}
																		/>
																	) : (
																		<span
																			onDoubleClick={() => handleEditGroup(g.id)} // double-click to edit
																			style={{ flexGrow: 1 }}
																		>
																			{g.name}
																		</span>
																	)}
																</div>

																{g.name !== "Default" && (

																	<FiTrash2 title="Delete" aria-label="Delete"
																		style={{
																			width: "38px",
																			height: "25px",
																			padding: "2px 2px",
																			cursor: "pointer",
																			justifyContent: "center",
																		}}
																		onClick={() => handleDeleteGroup(g.id)}  // Pass 'trash' as the type
																	/>
																)}
															</div>
														))}

														<button
															onClick={handleAddGroup}
															style={{
																marginTop: "10px",
																width: "100%",
																padding: "8px",
																border: "none",
																borderRadius: "6px",
																background: "#eee",
																cursor: "pointer",
															}}
														>
															Create New Group
														</button>
													</AccordionDetails>
												</Accordion>
											}


											{/* ✅ Space Settings Accordion */}
											{showParkOnly && (
												<Accordion
													expanded={expandedMarkSpace}
													onChange={handleMarkerAccordSpace}
													disableGutters
													square={false}
													sx={{
														flex: 1,
														backgroundColor: "white",
														borderRadius: "12px !important",
														boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
														"&:before": { display: "none" },
													}}
												>
													<AccordionSummary
														expandIcon={expandedMarkSpace ? <RemoveIcon /> : <AddIcon />}
														sx={{
															fontWeight: "bold",
															fontSize: "14px",
															minHeight: "48px",
															"& .MuiAccordionSummary-content": { margin: 0 },
														}}
													>
														Space Settings
													</AccordionSummary>

													<AccordionDetails
														sx={{
															padding: "8px 16px",
															backgroundColor: "white",
															borderRadius: "0 0 12px 12px",
														}}
													>
														<FormGroup>
															<FormControlLabel
																control={
																	<Checkbox
																		name="ParkingOnly"
																		checked={selectedMarkOption === "Parking Only" || onlyPark}
																		onChange={selectOption}
																	/>
																}
																label="Parking Only (No Pick/Drop)"
																sx={{
																	"& .MuiFormControlLabel-label": {
																		whiteSpace: "nowrap",
																		overflow: "hidden",
																		textOverflow: "ellipsis",
																	},
																}}
															/>

															<FormControlLabel
																control={
																	<Checkbox
																		name="RoboTaxis"
																		checked={RoboTaxis}
																		//checked={selectedRoboTaxiOption === "RoboTaxis"  || RoboTaxis }
																		onChange={AssignRoboTaxiSpaces}
																		disabled={pslCount === 0}
																	/>
																}
																label="Assign Spaces for RoboTaxis"
																sx={{
																	"& .MuiFormControlLabel-label": {
																		whiteSpace: "nowrap",
																		overflow: "hidden",
																		textOverflow: "ellipsis",
																	},
																}}
															/>
														</FormGroup>
													</AccordionDetails>
												</Accordion>
											)}

											{/* ✅ Points to Mark on the Map Accordion */}
											<Accordion
												expanded={expandedMark}
												onChange={handleMarkerAccord}
												disableGutters
												square={false}
												sx={{
													flex: 1,
													backgroundColor: "white",
													borderRadius: "12px !important",
													boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
													"&:before": { display: "none" },
												}}
											>
												<AccordionSummary
													expandIcon={expandedMark ? <RemoveIcon /> : <AddIcon />}
													sx={{
														fontWeight: "bold",
														fontSize: "14px",
														minHeight: "48px",
														"& .MuiAccordionSummary-content": { margin: 0 },
													}}
												>
													{showPickUPSDropoffs
														? "Points to Mark on the Map (Optional)"
														: "Points to Mark on the Map"}
												</AccordionSummary>

												<AccordionDetails
													sx={{
														padding: "8px 16px",
														backgroundColor: "white",
														borderRadius: "0 0 12px 12px",
													}}
												>
													{Object.entries(showPickUPSDropoffs ? PickUPSDropoffs : areas)
														.filter(([key]) => key !== "Searched Location")
														.map(([key, value]) => (
															<div
																key={key}
																className={`AccordName1 ${selectedOption === key ? "selected" : ""}`}
																onClick={() => handleselectedOption(key)}
																style={{
																	display: "flex",
																	alignItems: "center",
																	cursor: "pointer",
																	gap: "10px",
																	padding: "6px 0",
																	whiteSpace: "nowrap",
																	overflow: "hidden",
																	textOverflow: "ellipsis",
																}}
															>
																{/* count */}
																<span
																	style={{
																		display: "inline-block",
																		minWidth: minWidthStyle,
																		textAlign: "right",
																		flexShrink: 0,
																	}}
																>
																	<strong>{value}</strong>
																</span>

																{/* label */}
																<span style={{ flexGrow: 1 }}>{key}</span>

																{/* required marker */}
																{key === "PSL - Parking Space Location" && (
																	<span
																		style={{
																			color: "red",
																			fontWeight: 900,
																			fontSize: "1.2em",
																			marginLeft: "6px",
																			flexShrink: 0,
																		}}
																	>
																		*
																	</span>
																)}
															</div>
														))}
												</AccordionDetails>
											</Accordion>
										</div>
									)}

									<ToastContainer />


								</>
							</div>
						</div>
					) : (
						!bankdetails ? (
							<>
								<div style={{ marginLeft: '60px', marginRight: '80px', marginBottom: '-20px', marginTop: '15px' }}>
									<Alert severity="info">By default all <strong> marked</strong> parking spots are available 24/7 throughout the year(again you are not guaranteeing that the space will be open). This scheduler is used to designate the times when the marked parking spaces will <strong>not</strong> be allowed for use by Robotaxis</Alert>
								</div>

								<Scheduler
									// logEvents={logEvents}
									timeSlotesAvailability={timeSlotesAvailability}
									handleConfirm={handleConfirm}
									toggleCondition={toggleCondition}
									events={events}
									setEvents={setEvents}
									selectedDate={selectedDate}
									setSelectedDate={setSelectedDate}
									handleNavigate={handleNavigate}
									handleSave={(e) => handleSave(e)}
									isSaveDisabled={isSaveDisabled}
									newEventTriggered={newEventTriggered}
									//handleDeleteSave={handleDeleteEvent}
									selectedCountry={selectedCountry}
									groups={groups}
									areasMarked={areasMarked}
									selectedGroupFilter={selectedGroupFilter}
									setSelectedGroupFilter={setSelectedGroupFilter}
									selectedPSLCheckboxes={selectedPSLCheckboxes}
									setSelectedPSLCheckboxes={setSelectedPSLCheckboxes}
									setAreasMarked={setareasmarked}
									UpdatepslNames={UpdatepslNames}
									groupSchedules={groupSchedule}
									setGroupSchedules={setGroupSchedules}
									setIsScheduleDeleted={setIsScheduleDeleted}
								/>
							</>
						) : (
							!reviewlocation ? (
								<BankDetailsMain handlebankdetails={handlebankdetails} bankdetails={bankaccountdetails} entity={entity}
									handleReview={handleReview} validateFields={validateFields} handleInputChange={handleInputChange}
									errors={errorsbank} accountinfo={accountinfo} toggleCondition={toggleCondition} parkinglotObj={props.parkinglotObj}
									handleSave={handleSave} isSaveDisabled={isSaveDisabled} verificationstatus={props.verificationstatus} setSelectedBankDetailID={handleSelectedBankDetailID} mapVisibleChangesAlert={mapVisibleChangesAlert}
								/>) : (
								<ReviewAndConfirm handleReview={handleReview} areasMarked={areasMarked} addressvalue={addressvalue} SelectedBankDetailID={SelectedBankDetailID}
									accountinfo={accountinfo} bankdetails={accountinfo} EmailId={stateLogedInUser} latitude={latitude} longitude={longitude} toggleCondition={toggleCondition}
									handleviewparking={props.handleviewparking} defaultaddress={props.defaultaddress} entityId={entity} parkinglotObj={props.parkinglotObj} events={events} selectedValue={selectedValue}
									streetName={streetname} isSalespersonloggedin={props.isSalespersonloggedin} myworklistredirect={props.myworklistredirect} isautoSave={isautoSave} parkinglotId={parkinglotId}
									empId={props.empId} verificationstatus={props.verificationstatus} backToBankdetails={backToBankdetails} onlyPark={onlyPark} userData={props?.userData} selecetedAddress={selecetedAddress}
									verifiedBy={props.verifiedBy} PropertyNickName={PropertyNickName} region={selectedCountry} areaMarkedStatus={areaMarkedStatus} nickNameStatus={nickNameStatus} selectedAddLanLot={selectedAddLanLot} roboTaxiLimit={roboTaxiLimit} RoboTaxis={RoboTaxis} groups={groups} employeeData={employeeData} roboTaxiSpotsName={savedRoboTaxiPSLs} empRegistrationId={props?.empRegistrationId}
								/>

							)
						)
					)}
				</div>
			</div>
			{isFrameOpen && (
				<PortalPopup
					overlayColor="rgba(113, 113, 113, 0.3)"
					placement="Centered"
					disableOutsideClick={true}
				>
					<Frame1 defaultaddress={props.defaultaddress} isFrameOpen={isFrameOpen} onClose={closeFrame} enableMarker={enableMarker} isScheduleAvailabilityPopupConfirm={isScheduleAvailabilityPopupConfirm} isAddressSelected={isAddressSelected} userData={userData} employeeData={employeeData}
						currentPropertyaddress={currentPropertyaddress} />
				</PortalPopup>
			)}
			{isFrame1Open && (
				<PortalPopup
					overlayColor={!searchError ? "rgba(113, 113, 113, 0.3)" : "transparent"}
					placement="Centered"
					disableOutsideClick={true}
				>
					<Frame isFrame1Open={isFrame1Open} onClose={closeFrame1} handleContinue={handleContinue} isScheduleAvailabilityPopupConfirm={isScheduleAvailabilityPopupConfirm} isAddressSelected={isAddressSelected} isDashboard={isDashboard}
						alertpopup={alertpopup} handleSearchclick={handleSearchclick} handleAddressreset={handleAddressreset} areasMarked={areasMarked} addressvalue={addressvalue} defaultaddress={userData} employeeData={employeeData} navigateToDashboard={e => navigateToDashboard(true)}
						currentProperty={currentProperty} closeaddressReset={closeaddressReset} searchError={searchError} PropertyNickName={PropertyNickName}
					/>
				</PortalPopup>
			)}
			{(markingalert) && (<MarkingAlert markingalert={markingalert} handleCancelalert={handleCancelalert}
				currentMarker={currentMarker.current} areasMarkedCount={areasMarked.length} hasPSLEntry={areasMarked.some(area => area.Name === 'PSL - Parking Space Location')}
			/>)}
			{roboTaxiPopup && (
				<RoboTaxiPopup
					roboTaxiAlert={RoboTaxis && roboTaxiPopup}
					setRoboTaxiPopup={setRoboTaxiPopup}
					/* 🔽 ADD THESE */
					setRoboTaxis={setRoboTaxis}
					setSelectedRoboTaxiOption={setSelectedRoboTaxiOption}
					setRoboTaxiLimit={setRoboTaxiLimit}
					selectedPSL={draftRoboTaxiPSLs}
					setSelectedPSL={setDraftRoboTaxiPSLs}
					pslList={areasMarked
						.filter(a => a.Name === "PSL - Parking Space Location")
						.map(a => ({ id: a.id, label: a.pslName }))}
					roboTaxiCountError={roboTaxiCountError}
					setRoboTaxiCountError={setRoboTaxiCountError}
					handleSaveLimit={handleSaveLimit}
					onCancelRoboTaxi={handleRoboTaxiCancel}
				/>

			)}

			{/* {showSpotSizePopup && spotPopupPosition && (
				<div

					style={{
						position: "fixed",
						left: `${spotPopupPosition.x}px`,
						top: `${spotPopupPosition.y - 10}px`,
						transform: "translate(-50%, 0)", // center horizontally
						zIndex: 9999,
					}}
				>
					<SpotSizePopup

						onApply={handleSpotSizeApply}
						handleCancel={handleCancelPopUp}
					/>

				</div>
			)} */}
		</>
	);
};
export default MapDashboard;